import './style.css';
import { defineComponent, ref, computed, watch, onMounted, onBeforeUnmount, openBlock, createElementBlock, normalizeClass, createElementVNode, createCommentVNode, withDirectives, vShow, pushScopeId, popScopeId, createTextVNode, unref, normalizeStyle, createBlock, resolveDynamicComponent, mergeProps, withCtx, renderSlot, resolveComponent, Fragment, createVNode, createSlots, toDisplayString, renderList, Transition, onScopeDispose, nextTick, render, h } from 'vue';
import { v4 } from 'uuid';
import MusicPlayer from 'xgplayer-music';
import AudioMotionAnalyzer from 'audiomotion-analyzer';
import XgPlayer from 'xgplayer';
import HlsPlayer from 'xgplayer-hls.js';
import FlvPlayer from 'xgplayer-flv';

var audioPlayer_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".combine-audio[data-v-28deb61b] {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n.combine-audio .analyze-box[data-v-28deb61b] {\n  height: 100%;\n  background-color: #000;\n  padding-bottom: 50px;\n  box-sizing: border-box;\n}\n.combine-audio .analyze-box .inner[data-v-28deb61b] {\n  height: 100%;\n  position: relative;\n}\n.combine-audio .analyze-box .inner canvas[data-v-28deb61b] {\n  position: absolute;\n}\n.combine-audio .audio-inner[data-v-28deb61b] {\n  position: absolute;\n  height: 50px !important;\n  bottom: 0;\n}\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls {\n  padding: 0 6px;\n}\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-placeholder,\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-backward,\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-forward,\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-prev,\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-next {\n  display: none;\n}\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-play,\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-volume {\n  height: 100%;\n  margin: 0;\n}\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-play .xgplayer-icon,\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-volume .xgplayer-icon {\n  padding: 8px 0 0;\n  margin: 0;\n  width: 40px;\n  position: static;\n}\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-volume .xgplayer-icon {\n  padding: 15px 0 0;\n  height: 33px;\n}\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-time {\n  display: flex;\n  align-items: center;\n  top: 14px;\n}\n.combine-audio .audio-inner[data-v-28deb61b] .xgplayer-enter {\n  display: none;\n}\n.is--hidden--cover .audio-inner[data-v-28deb61b] .xgplayer-cover {\n  display: none;\n}\n.is--hidden--name .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-progress {\n  top: 28px;\n}\n.is--hidden--name .audio-inner[data-v-28deb61b] .xgplayer-controls .xgplayer-time {\n  top: 8px;\n}")();

var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

const AUDIO_MOTION_ANALYZER_CONF = {
  gradient: "prism",
  mode: 6,
  barSpace: 0.4,
  radial: true,
  spinSpeed: 1,
  showScaleX: false
};
const _sfc_main$k = defineComponent({
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: ""
    },
    audioConfig: {
      type: Object
    }
  },
  setup(props, { emit }) {
    const isHiddenCover = ref(false);
    const isHiddenName = ref(false);
    const containerRef = ref();
    const timer = ref(-1);
    const instance = ref(null);
    const playerId = computed(() => `player-${v4()}`);
    watch(
      () => !!instance.value,
      (isInit) => {
        if (isInit) {
          timer.value = setTimeout(() => {
            const container = containerRef.value;
            const audio = instance.value && instance.value.video;
            new AudioMotionAnalyzer(container, {
              ...AUDIO_MOTION_ANALYZER_CONF,
              source: audio
            });
          }, 300);
        }
      }
    );
    function initPlayer() {
      const { source, audioConfig } = props;
      const config = Object.assign(
        {
          preloadNext: false,
          volumeShow: true,
          poster: "",
          name: ""
        },
        audioConfig
      );
      isHiddenCover.value = !config.poster;
      isHiddenName.value = !config.name;
      const url = [
        {
          poster: config.poster,
          name: config.name,
          src: source
        }
      ];
      const id = playerId.value;
      const player = new MusicPlayer({
        ...config,
        id,
        url
      });
      player.on("error", () => emit("error"));
      player.on("ended", () => emit("ended"));
      player.on("pause", () => emit("pause"));
      player.on("play", () => emit("play"));
      player.mode = 0;
      player.crossOrigin = "anonymous";
      return player;
    }
    onMounted(() => {
      instance.value = initPlayer();
    });
    onBeforeUnmount(() => {
      if (instance.value) {
        instance.value = null;
      }
      if (timer.value) {
        clearTimeout(timer.value);
      }
    });
    return {
      isHiddenCover,
      isHiddenName,
      containerRef,
      playerId
    };
  }
});
const _hoisted_1$j = { class: "analyze-box" };
const _hoisted_2$h = {
  class: "inner",
  ref: "containerRef"
};
const _hoisted_3$f = ["id"];
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["combine-audio", {
      "is--hidden--cover": _ctx.isHiddenCover,
      "is--hidden--name": _ctx.isHiddenName
    }])
  }, [
    createElementVNode("div", _hoisted_1$j, [
      createElementVNode("div", _hoisted_2$h, null, 512)
    ]),
    createElementVNode("div", {
      class: "audio-inner",
      id: _ctx.playerId
    }, null, 8, _hoisted_3$f)
  ], 2);
}
var AudioPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k], ["__scopeId", "data-v-28deb61b"]]);

var videoPlayer_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".combine-video[data-v-6a002ac0] {\n  height: 100%;\n  width: 100%;\n}\n.combine-video.center[data-v-6a002ac0] {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.combine-video[data-v-6a002ac0] .xgplayer-enter .xgplayer-enter-spinner {\n  height: 11.11%;\n  width: 6.25%;\n}\n.combine-video[data-v-6a002ac0] .xgplayer-loading {\n  max-height: 60px;\n  max-width: 60px;\n  height: 16.66%;\n  width: 9.37%;\n  margin: 0;\n  transform: translate(-50%, -50%);\n}\n.combine-video[data-v-6a002ac0] .xgplayer-loading svg {\n  height: 100%;\n  width: 100%;\n}\n.combine-video[data-v-6a002ac0] .xgplayer-start {\n  max-height: 70px;\n  max-width: 70px;\n  height: 22.22%;\n  width: 12.5%;\n  line-height: 1;\n  margin: 0;\n  transform: translate(-50%, -50%);\n}\n.combine-video[data-v-6a002ac0] .xgplayer-start .xgplayer-icon-pause,\n.combine-video[data-v-6a002ac0] .xgplayer-start .xgplayer-icon-play {\n  height: 100%;\n  width: 100%;\n}\n.combine-video[data-v-6a002ac0] .xgplayer-start svg {\n  height: 100%;\n  width: 100%;\n}\n.combine-video[data-v-6a002ac0] .xgplayer-replay .xgplayer-replay-svg {\n  max-height: 70px;\n  max-width: 70px;\n  height: 22.22%;\n  width: 12.5%;\n}")();

const _sfc_main$j = defineComponent({
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: ""
    },
    videoConfig: {
      type: Object
    }
  },
  setup(props, { emit, expose }) {
    const instance = ref(null);
    const playerId = computed(() => `player-${v4()}`);
    function initPlayer() {
      const { source, videoConfig } = props;
      const config = Object.assign(
        {
          videoInit: true,
          autoplay: false,
          fluid: true,
          playsinline: true
        },
        videoConfig
      );
      const id = playerId.value;
      const player = createPlayerWithSource(id, source, config);
      player.on("error", () => emit("error"));
      player.on("ended", () => emit("ended"));
      player.on("pause", () => emit("pause"));
      player.on("play", () => emit("play"));
      return player;
    }
    function createPlayerWithSource(id, url, config) {
      let extension = "";
      const match = url.match(/\.([a-zA-Z0-9]+)(?=\?|$)/);
      if (match.length > 1) {
        extension = match[1].toLowerCase();
      }
      if (extension === "m3u8") {
        return new HlsPlayer({
          ...config,
          id,
          url
        });
      }
      return new XgPlayer({
        ...config,
        id,
        url
      });
    }
    onMounted(() => instance.value = initPlayer());
    onBeforeUnmount(() => {
      if (instance.value) {
        instance.value.destroy();
        instance.value = null;
      }
    });
    function getPlayerInstance() {
      return instance.value;
    }
    expose({
      getPlayerInstance
    });
    return {
      playerId
    };
  }
});
const _hoisted_1$i = ["id"];
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "combine-video center",
    id: _ctx.playerId
  }, null, 8, _hoisted_1$i);
}
var VideoPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j], ["__scopeId", "data-v-6a002ac0"]]);

var index_vue_vue_type_style_index_0_scoped_true_lang$2 = /* #__PURE__ */ (() => ".combine-img[data-v-0b322035] {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background-color: #000;\n  overflow: hidden;\n}\n.combine-img .loading[data-v-0b322035] {\n  display: block;\n  opacity: 1;\n  transform: rotate(165deg);\n  transition: opacity 5s cubic-bezier(0.47, 0, 0.74, 0.71);\n  height: 2.5em;\n  width: 2.5em;\n  line-height: 1.15;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -1.25em;\n  margin-top: -1.25em;\n}\n.combine-img .loading[data-v-0b322035]:before, .combine-img .loading[data-v-0b322035]:after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 0.5em;\n  height: 0.5em;\n  border-radius: 0.25em;\n  transform: translate(-50%, -50%);\n}\n.combine-img .loading[data-v-0b322035]:before {\n  animation: before-0b322035 2s infinite;\n}\n.combine-img .loading[data-v-0b322035]:after {\n  animation: after-0b322035 2s infinite;\n}\n.combine-img .error[data-v-0b322035] {\n  height: 100px;\n  width: 100px;\n  font-size: 12px;\n  color: #b2b2b2;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  user-select: none;\n  line-height: 1.2;\n  text-align: center;\n}\n.combine-img .error .error-img[data-v-0b322035] {\n  display: inline-block;\n  opacity: 0.5;\n  width: 60%;\n  vertical-align: middle;\n}\n.combine-img .error .error-img svg[data-v-0b322035] {\n  height: 100%;\n  width: 100%;\n}\n.combine-img .img[data-v-0b322035] {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n@keyframes before-0b322035 {\n0% {\n    width: 0.5em;\n    box-shadow: 1em -0.5em rgba(225, 20, 98, 0.75), -1em 0.5em rgba(111, 202, 220, 0.75);\n}\n35% {\n    width: 2.5em;\n    box-shadow: 0 -0.5em rgba(225, 20, 98, 0.75), 0 0.5em rgba(111, 202, 220, 0.75);\n}\n70% {\n    width: 0.5em;\n    box-shadow: -1em -0.5em rgba(225, 20, 98, 0.75), 1em 0.5em rgba(111, 202, 220, 0.75);\n}\n100% {\n    box-shadow: 1em -0.5em rgba(225, 20, 98, 0.75), -1em 0.5em rgba(111, 202, 220, 0.75);\n}\n}\n@keyframes after-0b322035 {\n0% {\n    height: 0.5em;\n    box-shadow: 0.5em 1em rgba(61, 184, 143, 0.75), -0.5em -1em rgba(233, 169, 32, 0.75);\n}\n35% {\n    height: 2.5em;\n    box-shadow: 0.5em 0 rgba(61, 184, 143, 0.75), -0.5em 0 rgba(233, 169, 32, 0.75);\n}\n70% {\n    height: 0.5em;\n    box-shadow: 0.5em -1em rgba(61, 184, 143, 0.75), -0.5em 1em rgba(233, 169, 32, 0.75);\n}\n100% {\n    box-shadow: 0.5em 1em rgba(61, 184, 143, 0.75), -0.5em -1em rgba(233, 169, 32, 0.75);\n}\n}")();

const _sfc_main$i = defineComponent({
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const isLoading = ref(true);
    const isError = ref(false);
    const containerRef = ref();
    const imgRef = ref();
    const canShow = computed(() => !(isLoading.value || isError.value));
    function handleImageSize(container, img) {
      const rect = container.getBoundingClientRect();
      let height = img.naturalHeight;
      let width = img.naturalWidth;
      const minRatio = Math.min(1, rect.width / width, rect.height / height);
      height = minRatio * height;
      width = minRatio * width;
      if (height > rect.height - 0.5)
        height = rect.height;
      if (width > rect.width - 0.5)
        width = rect.width;
      img.height = height + 1;
      img.width = width + 1;
    }
    onMounted(() => {
      imgRef.value && imgRef.value.addEventListener("error", () => {
        isLoading.value = false;
        isError.value = true;
      });
      imgRef.value && imgRef.value.addEventListener("load", () => {
        if (containerRef.value && imgRef.value) {
          handleImageSize(containerRef.value, imgRef.value);
        }
        emit("loaded");
        isLoading.value = false;
      });
    });
    return {
      isLoading,
      isError,
      containerRef,
      imgRef,
      canShow
    };
  }
});
const _withScopeId$5 = (n) => (pushScopeId("data-v-0b322035"), n = n(), popScopeId(), n);
const _hoisted_1$h = {
  class: "combine-img",
  ref: "containerRef"
};
const _hoisted_2$g = {
  key: 0,
  class: "loading"
};
const _hoisted_3$e = {
  key: 1,
  class: "error"
};
const _hoisted_4$6 = /* @__PURE__ */ _withScopeId$5(() => /* @__PURE__ */ createElementVNode("div", { class: "error-img" }, [
  /* @__PURE__ */ createElementVNode("svg", {
    class: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "200",
    height: "200"
  }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M304.128 456.192c48.64 0 88.064-39.424 88.064-88.064s-39.424-88.064-88.064-88.064-88.064 39.424-88.064 88.064 39.424 88.064 88.064 88.064zm0-116.224c15.36 0 28.16 12.288 28.16 28.16s-12.288 28.16-28.16 28.16-28.16-12.288-28.16-28.16 12.288-28.16 28.16-28.16z",
      fill: "#e6e6e6"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M887.296 159.744H136.704C96.768 159.744 64 192 64 232.448v559.104c0 39.936 32.256 72.704 72.704 72.704h198.144L500.224 688.64l-36.352-222.72 162.304-130.56-61.44 143.872 92.672 214.016-105.472 171.008h335.36C927.232 864.256 960 832 960 791.552V232.448c0-39.936-32.256-72.704-72.704-72.704zm-138.752 71.68v.512H857.6c16.384 0 30.208 13.312 30.208 30.208v399.872L673.28 408.064l75.264-176.64zM304.64 792.064H165.888c-16.384 0-30.208-13.312-30.208-30.208v-9.728l138.752-164.352 104.96 124.416-74.752 79.872zm81.92-355.84l37.376 228.864-.512.512-142.848-169.984c-3.072-3.584-9.216-3.584-12.288 0L135.68 652.8V262.144c0-16.384 13.312-30.208 30.208-30.208h474.624L386.56 436.224zm501.248 325.632c0 16.896-13.312 30.208-29.696 30.208H680.96l57.344-93.184-87.552-202.24 7.168-7.68 229.888 272.896z",
      fill: "#e6e6e6"
    })
  ])
], -1));
const _hoisted_5$3 = /* @__PURE__ */ _withScopeId$5(() => /* @__PURE__ */ createElementVNode("p", null, "\u56FE\u7247\u52A0\u8F7D\u5931\u8D25", -1));
const _hoisted_6$3 = [
  _hoisted_4$6,
  _hoisted_5$3
];
const _hoisted_7$3 = ["src"];
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$h, [
    _ctx.isLoading ? (openBlock(), createElementBlock("div", _hoisted_2$g)) : createCommentVNode("", true),
    _ctx.isError ? (openBlock(), createElementBlock("div", _hoisted_3$e, _hoisted_6$3)) : createCommentVNode("", true),
    withDirectives(createElementVNode("img", {
      class: "img",
      ref: "imgRef",
      src: _ctx.source,
      alt: "",
      draggable: "false"
    }, null, 8, _hoisted_7$3), [
      [vShow, _ctx.canShow]
    ])
  ], 512);
}
var ImgPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i], ["__scopeId", "data-v-0b322035"]]);

var index_vue_vue_type_style_index_0_scoped_true_lang$1 = /* #__PURE__ */ (() => ".combine-doc[data-v-03ac166e] {\n  height: 100%;\n  width: 100%;\n}\n.combine-doc .iframeMask[data-v-03ac166e] {\n  display: none;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 999;\n  filter: alpha(opacify=0);\n  opacity: 0;\n  background: transparent;\n}\n.combine-doc .iframe[data-v-03ac166e] {\n  height: 100%;\n  width: 100%;\n  background: #fff;\n  border: none;\n  margin: 0;\n  vertical-align: middle;\n}")();

const _sfc_main$h = defineComponent({
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const iframeRef = ref();
    onMounted(() => {
      iframeRef.value && iframeRef.value.addEventListener("load", () => {
        emit("loaded");
      });
    });
    return {
      iframeRef
    };
  }
});
const _withScopeId$4 = (n) => (pushScopeId("data-v-03ac166e"), n = n(), popScopeId(), n);
const _hoisted_1$g = { class: "combine-doc" };
const _hoisted_2$f = /* @__PURE__ */ _withScopeId$4(() => /* @__PURE__ */ createElementVNode("div", { class: "iframeMask" }, null, -1));
const _hoisted_3$d = ["src"];
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$g, [
    _hoisted_2$f,
    createElementVNode("iframe", {
      class: "iframe",
      ref: "iframeRef",
      src: _ctx.source
    }, null, 8, _hoisted_3$d)
  ]);
}
var DocPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h], ["__scopeId", "data-v-03ac166e"]]);

var _imports_2 = "data:image/png;base64,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";

var sorry_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".component-sorry[data-v-4df22e78] {\n  display: flex;\n  background-color: #fff;\n  border: 1px solid #e2e2e2;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.component-sorry p[data-v-4df22e78] {\n  margin-top: 20px;\n  font-size: 14px;\n  color: #b2b2b2;\n  text-align: center;\n}\n.component-sorry p .download-material[data-v-4df22e78] {\n  color: #5293F5;\n  text-decoration: none;\n  cursor: pointer;\n}")();

const _sfc_main$g = defineComponent({
  inheritAttrs: false,
  props: ["downloadUrl"]
});
const _withScopeId$3 = (n) => (pushScopeId("data-v-4df22e78"), n = n(), popScopeId(), n);
const _hoisted_1$f = { class: "component-sorry" };
const _hoisted_2$e = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("img", {
  src: _imports_2,
  alt: "unknown",
  width: "64",
  height: "64"
}, null, -1));
const _hoisted_3$c = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("span", null, "\u5F88\u62B1\u6B49\uFF0C\u8BE5\u6587\u4EF6\u6682\u4E0D\u652F\u6301\u5728\u7EBF\u9884\u89C8", -1));
const _hoisted_4$5 = { key: 0 };
const _hoisted_5$2 = /* @__PURE__ */ createTextVNode("\uFF0C\u53EF ");
const _hoisted_6$2 = ["href"];
const _hoisted_7$2 = /* @__PURE__ */ createTextVNode(" \u81F3\u672C\u5730\u67E5\u770B");
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$f, [
    _hoisted_2$e,
    createElementVNode("p", null, [
      _hoisted_3$c,
      _ctx.downloadUrl ? (openBlock(), createElementBlock("span", _hoisted_4$5, [
        _hoisted_5$2,
        createElementVNode("a", {
          href: _ctx.downloadUrl,
          class: "download-material"
        }, "\u70B9\u51FB\u4E0B\u8F7D", 8, _hoisted_6$2),
        _hoisted_7$2
      ])) : createCommentVNode("", true)
    ])
  ]);
}
var Sorry = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g], ["__scopeId", "data-v-4df22e78"]]);

var resPlayer_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".res-player[data-v-70c6ba58] {\n  font-family: PingFangSC-Regular, PingFang SC, sans-serif;\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n.res-player .player-wrap[data-v-70c6ba58] {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}")();

const _sfc_main$f = defineComponent({
  inheritAttrs: false,
  components: {
    AudioPlayer,
    VideoPlayer,
    ImgPlayer,
    DocPlayer,
    Sorry
  },
  props: {
    material: {
      type: Object,
      default: () => {
        return {};
      }
    },
    height: {
      type: [Number, String]
    },
    width: {
      type: [Number, String]
    },
    mode: String,
    isFullScreen: Boolean,
    withFullScreen: Boolean
  },
  setup(props, { slots, expose }) {
    const isMounted = ref(false);
    const containerRef = ref(null);
    const outerStyle = computed(() => {
      if (props.isFullScreen) {
        return {};
      }
      if (isMounted.value) {
        const domRect = containerRef.value && containerRef.value.getBoundingClientRect();
        if (domRect.height < 0.5) {
          return {
            paddingTop: "56.25%"
          };
        }
      }
    });
    const wrapStyle = computed(() => {
      if (isMounted.value) {
        const domRect = containerRef.value && containerRef.value.getBoundingClientRect();
        if (props.mode === "h5") {
          return {
            height: `100%`,
            width: "100%"
          };
        }
        const height = props.height || domRect.height || Infinity;
        const width = props.width || domRect.width || Infinity;
        const minRatio = Math.min(Number(height) / 9, Number(width) / 16);
        return {
          height: `${Math.round(9 * minRatio * 100) / 100}px`,
          width: `${Math.round(16 * minRatio * 100) / 100}px`
        };
      }
      return void 0;
    });
    const sourceType = computed(() => {
      return props.material.materialType;
    });
    const source = computed(() => {
      return props.material.previewUrl || props.material.materialUrl;
    });
    const player = computed(() => {
      if (unref(sourceType) && unref(source)) {
        switch (sourceType.value) {
          case "audio":
            return "AudioPlayer";
          case "video":
            return "VideoPlayer";
          case "img":
            return "ImgPlayer";
          case "doc":
          case "xls":
          case "ppt":
          case "pdf":
            return "DocPlayer";
          default:
            return slots.error || "Sorry";
        }
      }
      return slots.error || "Sorry";
    });
    const uuid = computed(() => {
      return Number(Math.random().toString().substr(3, 8) + Date.now()).toString(36).substr(3, 8);
    });
    onMounted(() => {
      isMounted.value = true;
    });
    onBeforeUnmount(() => {
      isMounted.value = false;
    });
    const playerRef = ref();
    function getPlayerInstance() {
      if (playerRef.value && playerRef.value.getPlayerInstance) {
        return playerRef.value.getPlayerInstance();
      }
    }
    expose({
      getPlayerInstance
    });
    return {
      containerRef,
      outerStyle,
      playerRef,
      isMounted,
      wrapStyle,
      source,
      player,
      uuid
    };
  }
});
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "res-player",
    ref: "containerRef",
    style: normalizeStyle(_ctx.outerStyle)
  }, [
    createElementVNode("div", {
      class: "player-wrap",
      style: normalizeStyle(_ctx.wrapStyle)
    }, [
      _ctx.isMounted ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.player), mergeProps({
        key: 0,
        ref: "playerRef",
        key: _ctx.uuid,
        source: _ctx.source
      }, _ctx.$attrs), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "error", {}, void 0, true)
        ]),
        _: 3
      }, 16, ["source"])) : createCommentVNode("", true)
    ], 4)
  ], 4);
}
var ResPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f], ["__scopeId", "data-v-70c6ba58"]]);

function isEmptyObject$1(obj) {
  let property;
  for (property in obj) {
    return false;
  }
  return true;
}
function downloadURLFormat(material) {
  switch (material.ispType) {
    case "qiNiu":
    case "srt":
    case "ctYun":
      return `${material.materialUrl}?attname=${material.materialFullName}`;
    case "oss":
      return `${material.materialUrl}?response-content-type=application/octet-stream`;
    default:
      return;
  }
}

function request(url, method, config, params) {
  if (isEmptyObject$1(config)) {
    throw new Error("request config cannot be empty.");
  }
  const headers = new Headers();
  headers.append("X-DT-accessToken", config.accessToken);
  headers.append("X-DT-clientId", config.clientId);
  headers.append("Content-Type", "application/json");
  if (method == "POST") {
    return fetch(`${config.apiHost}${url}`, {
      headers,
      method,
      body: JSON.stringify(params.data),
      mode: "cors"
    }).then((response) => response.json()).then((data) => data.data);
  }
  const searchParams = new URLSearchParams(params.queries);
  const qs = searchParams.toString();
  return fetch(`${config.apiHost}${url}?${qs}`, {
    headers,
    method,
    mode: "cors"
  }).then((response) => response.json()).then((data) => data.data);
}

/* eslint-disable promise/prefer-await-to-then */

const methodMap = [
	[
		'requestFullscreen',
		'exitFullscreen',
		'fullscreenElement',
		'fullscreenEnabled',
		'fullscreenchange',
		'fullscreenerror',
	],
	// New WebKit
	[
		'webkitRequestFullscreen',
		'webkitExitFullscreen',
		'webkitFullscreenElement',
		'webkitFullscreenEnabled',
		'webkitfullscreenchange',
		'webkitfullscreenerror',

	],
	// Old WebKit
	[
		'webkitRequestFullScreen',
		'webkitCancelFullScreen',
		'webkitCurrentFullScreenElement',
		'webkitCancelFullScreen',
		'webkitfullscreenchange',
		'webkitfullscreenerror',

	],
	[
		'mozRequestFullScreen',
		'mozCancelFullScreen',
		'mozFullScreenElement',
		'mozFullScreenEnabled',
		'mozfullscreenchange',
		'mozfullscreenerror',
	],
	[
		'msRequestFullscreen',
		'msExitFullscreen',
		'msFullscreenElement',
		'msFullscreenEnabled',
		'MSFullscreenChange',
		'MSFullscreenError',
	],
];

const nativeAPI = (() => {
	if (typeof document === 'undefined') {
		return false;
	}

	const unprefixedMethods = methodMap[0];
	const returnValue = {};

	for (const methodList of methodMap) {
		const exitFullscreenMethod = methodList && methodList[1];
		if (exitFullscreenMethod in document) {
			for (const [index, method] of methodList.entries()) {
				returnValue[unprefixedMethods[index]] = method;
			}

			return returnValue;
		}
	}

	return false;
})();

const eventNameMap = {
	change: nativeAPI.fullscreenchange,
	error: nativeAPI.fullscreenerror,
};

// eslint-disable-next-line import/no-mutable-exports
let screenfull = {
	// eslint-disable-next-line default-param-last
	request(element = document.documentElement, options) {
		return new Promise((resolve, reject) => {
			const onFullScreenEntered = () => {
				screenfull.off('change', onFullScreenEntered);
				resolve();
			};

			screenfull.on('change', onFullScreenEntered);

			const returnPromise = element[nativeAPI.requestFullscreen](options);

			if (returnPromise instanceof Promise) {
				returnPromise.then(onFullScreenEntered).catch(reject);
			}
		});
	},
	exit() {
		return new Promise((resolve, reject) => {
			if (!screenfull.isFullscreen) {
				resolve();
				return;
			}

			const onFullScreenExit = () => {
				screenfull.off('change', onFullScreenExit);
				resolve();
			};

			screenfull.on('change', onFullScreenExit);

			const returnPromise = document[nativeAPI.exitFullscreen]();

			if (returnPromise instanceof Promise) {
				returnPromise.then(onFullScreenExit).catch(reject);
			}
		});
	},
	toggle(element, options) {
		return screenfull.isFullscreen ? screenfull.exit() : screenfull.request(element, options);
	},
	onchange(callback) {
		screenfull.on('change', callback);
	},
	onerror(callback) {
		screenfull.on('error', callback);
	},
	on(event, callback) {
		const eventName = eventNameMap[event];
		if (eventName) {
			document.addEventListener(eventName, callback, false);
		}
	},
	off(event, callback) {
		const eventName = eventNameMap[event];
		if (eventName) {
			document.removeEventListener(eventName, callback, false);
		}
	},
	raw: nativeAPI,
};

Object.defineProperties(screenfull, {
	isFullscreen: {
		get: () => Boolean(document[nativeAPI.fullscreenElement]),
	},
	element: {
		enumerable: true,
		get: () => document[nativeAPI.fullscreenElement] || undefined,
	},
	isEnabled: {
		enumerable: true,
		// Coerce to boolean in case of old WebKit.
		get: () => Boolean(document[nativeAPI.fullscreenEnabled]),
	},
});

if (!nativeAPI) {
	screenfull = {isEnabled: false};
}

var screenFull = screenfull;

var _imports_0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAY9JREFUWEftmLlOxDAQhv/ZAiSOl7DfDCFRIcRRQZOGrTgE3Qq0Rd5r5iU4JCgwMtpEjkl8rDbgImntGX/+/SeZMWmtrwFcGGO2EHiI6BPADTNfheb5Y7n5SWv9EYNpFiGiV2bezwR6McbspcTYTZNSyqROHlOhdtMDQEtmPiSiJNiUDblzjDH2ZJ4BHPixIYVGgQrBWDgfaOlRbxRqAKazZgeImWc9Um4EagjGWkNr/dXrIRGhUOC6norldH3cUcgCWdJYghwTp+SKAgWg7kXkLAdIKXUH4NSJ+WWBDlDzYbQfJWbedherqmpW1/WTY/R3EdnNBHoDsLOK6fWjy2CPbE5ExwAe+34LK8lvARwBeBCRy0ygOYATAAtmPu/zocvw45mSngkodhqTQpNCMQVi45OHJoViCsTGy/NQcT/XUPnRU1z9SfnRtjpNxfivBZpbrRVZwqbUwLE3xR+P5RysqYtrgwCU1Sh6Um+kQUw8vnbaUG8/Ckyz6rqXDZ3NjX1h1bbSxV1Y5V65jX2l9w11NJvEgRzaSgAAAABJRU5ErkJggg==";

var _imports_1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAb9JREFUWEftmMFKxDAQhr9RVw+K4BMK6kEPgqh4EbyIgqIrePGigi+oLOhBXXdkSirdtCbtml0qNLc2k8nXyeRvJqKqJ8A+8AAciojiNWezB9yJyLHfH3pW1TNgB7gRkdMK3wJcAZtAX1R1AKw6w0dgy4dS1VdgGRgCSyIyqgOlqnPAO7AAvInISnGcqhrMPbDh3g8M6NpFKLctQanqp3NqNj0RMbBoU1UDsbHWhiLSywdVwFhXFiGf0jrGoFIDBee02WNQKYFic1l0shYyBD5SLBmw6OVMaTV+gCJQ68C8Y580h76Ap0ICl2DsxRhQAKqYwJMC+ZugckeXgGpApQCqhMki5ETvyPTF+wSDzZcpdYRs+XwBNr26MKBnYC0qKk5L/iCMdaZ4MSCTdouQiViomRjeishBHc+F3dsHdmv6v8xyyEm8yXyojer+MnwnTfxXJnWTCKS27YBiEe0i1EUoFoFYf5dD/zNCTaQ99oVV/U38t+/n2sbjh1Wu7Tmg/bLmVbVabjrdI2zF2SUEY+YpgMxP/JAfqM1mXwa1qlCMlbczLaVjMO7MnfT2IzhnG69jWndhNe0rvXNgu+6V3jej3JPiD/S9awAAAABJRU5ErkJggg==";

var materialResPlayer_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".material-res-player-pc[data-v-5f03cf41] {\n  min-height: 380px;\n}\n.material-res-player[data-v-5f03cf41], #materialResPlayer[data-v-5f03cf41] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.loading-wrapper[data-v-5f03cf41],\n.empty-wrapper[data-v-5f03cf41] {\n  background-color: #ffffff;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.loading-wrapper[data-v-5f03cf41] {\n  position: absolute;\n  opacity: 0.95;\n}\n.loading-wrapper .loader[data-v-5f03cf41] {\n  width: 30px;\n  height: 30px;\n  position: relative;\n}\n.loading-wrapper .loader .circular[data-v-5f03cf41] {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  top: 0;\n  margin: auto;\n  transform-origin: center center;\n  animation: rotate-5f03cf41 2s linear infinite;\n}\n.loading-wrapper .loader .path[data-v-5f03cf41] {\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  animation: dash-5f03cf41 1.5s ease-in-out infinite,color-5f03cf41 6s ease-in-out infinite;\n  stroke-linecap: round;\n}\n@keyframes rotate-5f03cf41 {\nto {\n    transform: rotate(1turn);\n}\n}\n@keyframes color-5f03cf41 {\n0%, to {\n    stroke: #d62d20;\n}\n40% {\n    stroke: #0057e7;\n}\n66% {\n    stroke: #008744;\n}\n80%, 90% {\n    stroke: #ffa700;\n}\n}\n@keyframes dash-5f03cf41 {\n0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n}\n50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35;\n}\nto {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124;\n}\n}\n.empty-wrapper .empty img[data-v-5f03cf41] {\n  height: 64px;\n  width: 64px;\n  vertical-align: middle;\n}\n.empty-wrapper .empty p[data-v-5f03cf41] {\n  font-family: PingFangSC-Regular, PingFang SC, sans-serif;\n  margin-top: 15px;\n  font-size: 14px;\n  color: #b2b2b2;\n}\n.empty-wrapper .empty p .download-material[data-v-5f03cf41] {\n  color: #5293F5;\n  text-decoration: none;\n  cursor: pointer;\n}\n.toggle-fullscreen[data-v-5f03cf41] {\n  position: relative;\n  height: 40px;\n  background: #e9e9e9;\n  text-align: right;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  box-sizing: border-box;\n  padding-right: 20px;\n}\n.toggle-fullscreen img[data-v-5f03cf41] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n.can-fullscreen[data-v-5f03cf41] {\n  background: #e9e9e9;\n  height: auto;\n  box-sizing: border-box;\n}\n.can-fullscreen.can-fullscreen-h5[data-v-5f03cf41] {\n  height: calc(100% - 40px);\n  padding: 0;\n}\n.can-fullscreen .material-res-player[data-v-5f03cf41] {\n  height: calc(100% - 40px) !important;\n}\n.full-screen[data-v-5f03cf41] {\n  padding: 0;\n}\n.full-screen.can-fullscreen[data-v-5f03cf41] {\n  height: calc(100% - 40px);\n}\n.full-screen .toggle-fullscreen[data-v-5f03cf41] {\n  background-color: #333333;\n  padding-right: 20px;\n}\n.full-screen[data-v-5f03cf41] .player-wrap {\n  width: 100% !important;\n  height: 100% !important;\n}")();

const _sfc_main$e = defineComponent({
  inheritAttrs: false,
  components: {
    ResPlayer
  },
  props: {
    withFullScreen: {
      type: Boolean,
      default: false
    },
    material: {
      type: Object,
      default: () => {
        return {};
      }
    },
    downloadable: {
      type: Boolean,
      default: false
    },
    requestConfig: {
      type: Object,
      default: void 0
    },
    mode: {
      type: String,
      default: ""
    }
  },
  setup(props, { attrs, expose }) {
    const loading = ref(false);
    const source = ref({});
    const isFullScreen = ref(false);
    const materialResPlayerRef = ref();
    const downloadUrl = computed(() => {
      return props.downloadable && downloadURLFormat(unref(source));
    });
    const sourceType = computed(() => {
      const sourceMap = ["doc", "ppt", "pptx", "docx", "pdf", "xlsx", "xls"];
      const type = source.value && source.value.materialType || "";
      return sourceMap.includes(type);
    });
    const isUsable = computed(() => {
      let temp = source.value && source.value.materialStatus;
      return temp === "usable" || false;
    });
    const className = computed(() => {
      let temp = props.withFullScreen ? {
        "can-fullscreen-h5": isUsable.value && sourceType.value && props.mode === "h5",
        "can-fullscreen": isUsable.value && sourceType.value,
        "full-screen": isFullScreen.value
      } : {};
      return {
        ...temp,
        "material-res-player-pc": props.mode !== "h5",
        "material-res-player-h5": props.mode === "h5"
      };
    });
    watch(
      () => props.material,
      async (material) => {
        if (material.materialId && material.materialStatus !== "usable") {
          material = await getMaterialDetail(material.materialId);
        }
        source.value = Object.assign({}, material);
      },
      {
        immediate: true
      }
    );
    async function getMaterialDetail(materialId) {
      const material = props.material;
      if (props.requestConfig) {
        loading.value = true;
        return await request("/material-center/detail/v2", "POST", props.requestConfig, { data: { materialId } }).then((data) => data || material).catch(() => material).finally(() => loading.value = false);
      }
      return material;
    }
    const playerRef = ref();
    function getInstance() {
      if (playerRef.value) {
        return playerRef.value.getPlayerInstance();
      }
    }
    function toggleFullScreen() {
      if (screenFull.isEnabled && materialResPlayerRef.value) {
        screenFull.toggle(materialResPlayerRef.value);
      }
    }
    function fullChange() {
      isFullScreen.value = screenFull.isFullscreen;
    }
    expose({
      getInstance
    });
    onMounted(() => {
      screenFull.on("change", fullChange);
    });
    onBeforeUnmount(() => {
      screenFull.off("change", fullChange);
    });
    return {
      playerRef,
      materialResPlayerRef,
      loading,
      source,
      downloadUrl,
      sourceType,
      isFullScreen,
      isUsable,
      toggleFullScreen,
      className
    };
  }
});
const _withScopeId$2 = (n) => (pushScopeId("data-v-5f03cf41"), n = n(), popScopeId(), n);
const _hoisted_1$e = { class: "material-res-player" };
const _hoisted_2$d = {
  key: 0,
  class: "loading-wrapper"
};
const _hoisted_3$b = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("div", { class: "loader" }, [
  /* @__PURE__ */ createElementVNode("svg", {
    viewBox: "25 25 50 50",
    class: "circular"
  }, [
    /* @__PURE__ */ createElementVNode("circle", {
      cx: "50",
      cy: "50",
      r: "20",
      fill: "none",
      "stroke-width": "5",
      "stroke-miterlimit": "10",
      class: "path"
    })
  ])
], -1));
const _hoisted_4$4 = [
  _hoisted_3$b
];
const _hoisted_5$1 = {
  key: 0,
  class: "toggle-fullscreen"
};
const _hoisted_6$1 = {
  src: _imports_0,
  alt: ""
};
const _hoisted_7$1 = {
  src: _imports_1,
  alt: ""
};
const _hoisted_8$1 = {
  key: 1,
  class: "empty-wrapper"
};
const _hoisted_9$1 = { class: "empty" };
const _hoisted_10 = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { key: 1 };
const _hoisted_13 = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("span", null, "\u5F88\u62B1\u6B49\uFF0C\u8BE5\u6587\u4EF6\u6682\u4E0D\u652F\u6301\u5728\u7EBF\u9884\u89C8", -1));
const _hoisted_14 = { key: 0 };
const _hoisted_15 = /* @__PURE__ */ createTextVNode("\uFF0C\u53EF ");
const _hoisted_16 = ["href"];
const _hoisted_17 = /* @__PURE__ */ createTextVNode(" \u81F3\u672C\u5730\u67E5\u770B");
const _hoisted_18 = { key: 2 };
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ResPlayer = resolveComponent("ResPlayer");
  return openBlock(), createElementBlock("div", {
    ref: "materialResPlayerRef",
    id: "materialResPlayer",
    class: normalizeClass(_ctx.className)
  }, [
    createElementVNode("div", _hoisted_1$e, [
      _ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_2$d, _hoisted_4$4)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        _ctx.isUsable ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createVNode(_component_ResPlayer, mergeProps({
            ref: "playerRef",
            material: _ctx.material,
            "download-url": _ctx.downloadUrl
          }, _ctx.$attrs, {
            mode: _ctx.mode,
            withFullScreen: _ctx.withFullScreen,
            isFullScreen: _ctx.isFullScreen
          }), createSlots({ _: 2 }, [
            _ctx.$slots.error ? {
              name: "error",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "error", {}, void 0, true)
              ])
            } : void 0
          ]), 1040, ["material", "download-url", "mode", "withFullScreen", "isFullScreen"]),
          renderSlot(_ctx.$slots, "fullScreen", {}, () => [
            _ctx.withFullScreen && _ctx.sourceType && _ctx.isUsable ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
              createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = (...args) => _ctx.toggleFullScreen && _ctx.toggleFullScreen(...args))
              }, [
                withDirectives(createElementVNode("img", _hoisted_6$1, null, 512), [
                  [vShow, !_ctx.isFullScreen]
                ]),
                withDirectives(createElementVNode("img", _hoisted_7$1, null, 512), [
                  [vShow, _ctx.isFullScreen]
                ])
              ])
            ])) : createCommentVNode("", true)
          ], true)
        ], 64)) : (openBlock(), createElementBlock("div", _hoisted_8$1, [
          renderSlot(_ctx.$slots, "empty", {}, () => [
            createElementVNode("div", _hoisted_9$1, [
              _hoisted_10,
              _ctx.source.materialStatus === "transcoding" ? (openBlock(), createElementBlock("p", _hoisted_11, "\u6B63\u5728\u5904\u7406\u6210\u6D4F\u89C8\u5668\u53EF\u64AD\u653E\u7684\u683C\u5F0F\uFF0C\u5904\u7406\u65F6\u957F\u4E0E\u6587\u4EF6\u5927\u5C0F\u548C\u683C\u5F0F\u6709\u5173\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85")) : _ctx.source.materialStatus === "failed" ? (openBlock(), createElementBlock("p", _hoisted_12, [
                _hoisted_13,
                _ctx.downloadUrl ? (openBlock(), createElementBlock("span", _hoisted_14, [
                  _hoisted_15,
                  createElementVNode("a", {
                    href: _ctx.downloadUrl,
                    class: "download-material"
                  }, "\u70B9\u51FB\u4E0B\u8F7D", 8, _hoisted_16),
                  _hoisted_17
                ])) : createCommentVNode("", true)
              ])) : (openBlock(), createElementBlock("p", _hoisted_18, "\u683C\u5F0F\u6709\u8BEF\uFF0C\u6682\u4E0D\u652F\u6301\u64AD\u653E"))
            ])
          ], true)
        ]))
      ], 64))
    ])
  ], 2);
}
var MaterialResPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e], ["__scopeId", "data-v-5f03cf41"]]);

var livePlayer_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".live-player[data-v-29ef35ca] {\n  height: 100%;\n  width: 100%;\n}\n.live-player[data-v-29ef35ca] .xgplayer-enter-spinner {\n  height: 60px;\n  width: 60px;\n}\n.live-player[data-v-29ef35ca] .xgplayer-loading {\n  transform: scale(0.6);\n  transform-origin: center center;\n}")();

const _sfc_main$d = defineComponent({
  props: {
    url: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => {
      }
    },
    qualities: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const instance = ref(null);
    const playerId = computed(() => `living-${v4()}`);
    function initPlayer() {
      const { url, config, qualities } = props;
      const id = playerId.value;
      const player = new FlvPlayer({
        autoplay: true,
        playsinline: true,
        ...config,
        id,
        url,
        isLive: true,
        fluid: true
      });
      if (qualities.length) {
        player.emit("resourceReady", qualities);
      }
      player.on("error", () => emit("error"));
      player.on("ended", () => emit("ended"));
      player.on("pause", () => emit("pause"));
      player.on("play", () => emit("play"));
      return player;
    }
    onMounted(() => {
      instance.value = initPlayer();
    });
    onBeforeUnmount(() => {
      if (instance.value) {
        instance.value.destroy();
        instance.value = null;
      }
    });
    return {
      playerId
    };
  }
});
const _hoisted_1$d = ["id"];
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "live-player",
    id: _ctx.playerId
  }, null, 8, _hoisted_1$d);
}
var livePlayer = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d], ["__scopeId", "data-v-29ef35ca"]]);

const _sfc_main$c = {};

const _hoisted_1$c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "36",
  height: "36",
  fill: "currentColor"
};
const _hoisted_2$c = /*#__PURE__*/createElementVNode("path", { d: "M512 467.34L271.624 226.965a31.562 31.562 0 0 0-44.643 44.66L467.357 512 226.98 752.376a31.562 31.562 0 1 0 44.643 44.626l240.36-240.359L752.358 797.02a31.562 31.562 0 0 0 44.66-44.66L556.643 511.983l240.36-240.359a31.562 31.562 0 0 0-44.627-44.643L512 467.341z" }, null, -1);
const _hoisted_3$a = [
  _hoisted_2$c
];

function _sfc_render$c(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$c, _hoisted_3$a))
}
var IconClose = /*#__PURE__*/_export_sfc(_sfc_main$c, [['render',_sfc_render$c]]);

const _sfc_main$b = {};

const _hoisted_1$b = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "40",
  height: "40",
  fill: "currentColor"
};
const _hoisted_2$b = /*#__PURE__*/createElementVNode("path", { d: "M399.46 512l283.3-281.088c10.736-10.653 10.736-27.929 0-38.565a27.631 27.631 0 0 0-38.862 0l-302.74 300.362a27.136 27.136 0 0 0 0 38.582l302.74 300.362c10.735 10.653 28.127 10.653 38.862 0 10.736-10.636 10.736-27.912 0-38.565L399.46 512z" }, null, -1);
const _hoisted_3$9 = [
  _hoisted_2$b
];

function _sfc_render$b(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$b, _hoisted_3$9))
}
var IconPrev = /*#__PURE__*/_export_sfc(_sfc_main$b, [['render',_sfc_render$b]]);

const _sfc_main$a = {};

const _hoisted_1$a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "40",
  height: "40",
  fill: "currentColor"
};
const _hoisted_2$a = /*#__PURE__*/createElementVNode("path", { d: "M624.458 512l-283.3 281.088a27.12 27.12 0 0 0 0 38.565c10.735 10.653 28.143 10.653 38.878 0L682.76 531.291c10.736-10.653 10.736-27.929 0-38.582L380.036 192.347a27.648 27.648 0 0 0-38.879 0c-10.735 10.636-10.735 27.912 0 38.565L624.458 512z" }, null, -1);
const _hoisted_3$8 = [
  _hoisted_2$a
];

function _sfc_render$a(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$a, _hoisted_3$8))
}
var IconNext = /*#__PURE__*/_export_sfc(_sfc_main$a, [['render',_sfc_render$a]]);

var indicator_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".stage-indicator .navigator .navigator-prev[data-v-e03df19e],\n.stage-indicator .navigator .navigator-next[data-v-e03df19e] {\n  height: 60px;\n  width: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  margin-top: -30px;\n  font-weight: bold;\n  font-size: 40px;\n  color: #fff;\n  text-shadow: 0 0 1px #b4b3b4;\n  background-color: #111;\n  border-radius: 50%;\n  opacity: 0.9;\n  cursor: pointer;\n  transition: transform 336ms;\n  box-sizing: border-box;\n  z-index: 1;\n}\n.stage-indicator .navigator .navigator-prev[data-v-e03df19e]:hover,\n.stage-indicator .navigator .navigator-next[data-v-e03df19e]:hover {\n  background-color: rgba(85, 85, 85, 0.4);\n}\n.stage-indicator .navigator .navigator-prev[data-v-e03df19e] {\n  padding-right: 2px;\n  left: 0;\n  transform: translateX(-100%);\n}\n.stage-indicator .navigator .navigator-next[data-v-e03df19e] {\n  padding-left: 2px;\n  right: 0;\n  transform: translateX(100%);\n}\n.stage-indicator .indicator[data-v-e03df19e] {\n  height: 28px;\n  width: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  bottom: 100px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(85, 85, 85, 0.4);\n  border-radius: 14px;\n  font-size: 14px;\n  color: #fff;\n  opacity: 0;\n  cursor: pointer;\n  visibility: hidden;\n  transition: opacity 0.25s ease, visibility 0s ease 0.25s;\n  z-index: 1;\n}")();

const _sfc_main$9 = defineComponent({
  components: {
    IconPrev,
    IconNext
  },
  props: {
    count: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    }
  }
});
const _hoisted_1$9 = { class: "stage-indicator" };
const _hoisted_2$9 = { class: "navigator" };
const _hoisted_3$7 = { class: "indicator" };
const _hoisted_4$3 = /* @__PURE__ */ createTextVNode("/");
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconPrev = resolveComponent("IconPrev");
  const _component_IconNext = resolveComponent("IconNext");
  return openBlock(), createElementBlock("div", _hoisted_1$9, [
    createElementVNode("div", _hoisted_2$9, [
      withDirectives(createElementVNode("i", {
        class: "navigator-prev",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("on-prev"))
      }, [
        createVNode(_component_IconPrev, {
          stroke: "#FFF",
          "stroke-width": "60"
        })
      ], 512), [
        [vShow, _ctx.index > 0]
      ]),
      withDirectives(createElementVNode("i", {
        class: "navigator-next",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("on-next"))
      }, [
        createVNode(_component_IconNext, {
          stroke: "#FFF",
          "stroke-width": "60"
        })
      ], 512), [
        [vShow, _ctx.index < _ctx.count - 1]
      ])
    ]),
    createElementVNode("div", _hoisted_3$7, [
      createElementVNode("span", null, toDisplayString(_ctx.index + 1), 1),
      _hoisted_4$3,
      createElementVNode("span", null, toDisplayString(_ctx.count), 1)
    ])
  ]);
}
var Indicator = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9], ["__scopeId", "data-v-e03df19e"]]);

function useResizer(callback) {
  window.addEventListener("resize", callback);
  return {
    destroy() {
      window.removeEventListener("resize", callback);
    }
  };
}

var thumbnail_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".stage-thumbnail .thumbnail[data-v-4b4edd22] {\n  position: absolute;\n  bottom: -80px;\n  height: 80px;\n  width: 100%;\n  z-index: 1;\n  background-color: #313131;\n  transition: bottom 336ms;\n}\n.stage-thumbnail .thumb-page-prev[data-v-4b4edd22],\n.stage-thumbnail .thumb-page-next[data-v-4b4edd22] {\n  float: left;\n  background-color: transparent;\n  line-height: 80px;\n  height: 80px;\n  width: 30px;\n  text-align: center;\n  cursor: pointer;\n  border: 0;\n  color: #6f6f6f;\n  font-size: 18px;\n}\n.stage-thumbnail .thumb-page-prev.enabled[data-v-4b4edd22],\n.stage-thumbnail .thumb-page-next.enabled[data-v-4b4edd22] {\n  color: #fff;\n}\n.stage-thumbnail .thumb-page-prev.enabled[data-v-4b4edd22]:hover,\n.stage-thumbnail .thumb-page-next.enabled[data-v-4b4edd22]:hover {\n  color: #5293f5;\n}\n.stage-thumbnail .thumb-page-next[data-v-4b4edd22] {\n  float: right;\n}\n.stage-thumbnail .thumb-list[data-v-4b4edd22] {\n  padding: 10px 0;\n  margin: 0 30px;\n  height: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-align: center;\n  box-sizing: border-box;\n}\n.stage-thumbnail .thumb-item[data-v-4b4edd22] {\n  display: inline-block;\n  height: 60px;\n  width: 60px;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-clip: content-box;\n  position: relative;\n}\n.stage-thumbnail .thumb-item[data-v-4b4edd22]::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background-color: #000;\n  opacity: 0.8;\n}\n.stage-thumbnail .thumb-item[data-v-4b4edd22]:hover::before {\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n.stage-thumbnail .thumb-item.thumb-item-active[data-v-4b4edd22]::before {\n  opacity: 0;\n}")();

const _sfc_main$8 = defineComponent({
  components: {
    IconPrev,
    IconNext
  },
  props: {
    thumbnails: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit, expose }) {
    const isNeedPage = ref(false);
    const margin = ref(0);
    const pageIndex = ref(0);
    const pageSize = ref(0);
    const pageNum = ref(0);
    const thresholds = ref([]);
    const thumbListRef = ref();
    const thumbs = computed(() => {
      let thumbs2 = props.thumbnails;
      let pageStart = pageIndex.value * pageSize.value;
      return Array.prototype.slice.call(thumbs2, pageStart, pageStart + pageSize.value);
    });
    watch(pageSize, () => {
      thresholds.value = [];
      for (let i = 1; i <= pageNum.value; i++) {
        thresholds.value.push(i * pageSize.value);
      }
    });
    watch(
      () => props.index,
      () => {
        pageIndex.value = thresholds.value.findIndex((t) => props.index < t);
      }
    );
    let resizer;
    function adjustLayout() {
      if (props.thumbnails.length <= 1) {
        return;
      }
      let _listClientWidth = thumbListRef.value.clientWidth;
      let _itemClientWidth = 60;
      let _minMargin = 5;
      let _requiredWidth = props.thumbnails.length * (_itemClientWidth + _minMargin);
      if (_listClientWidth <= _requiredWidth) {
        isNeedPage.value = true;
        pageSize.value = Math.floor(_listClientWidth / (_itemClientWidth + _minMargin));
        pageNum.value = Math.ceil(props.thumbnails.length / pageSize.value);
        pageIndex.value = Math.floor(props.index / pageSize.value);
        margin.value = (_listClientWidth - _itemClientWidth * pageSize.value) / pageSize.value;
      } else {
        isNeedPage.value = false;
        pageSize.value = props.thumbnails.length;
        pageNum.value = 1;
        pageIndex.value = 0;
        margin.value = _minMargin;
      }
    }
    function reset() {
      resizer.destroy();
    }
    function init() {
      adjustLayout();
      resizer = useResizer(() => adjustLayout());
    }
    function thumbnailClasses(index) {
      return [
        "thumb-item",
        { "thumb-item-active": index + pageIndex.value * pageSize.value === props.index }
      ];
    }
    function thumbnailStyle(thumb) {
      return {
        "background-image": `url(${thumb})`,
        "margin-right": `${margin.value}px`
      };
    }
    function pagePrev() {
      if (pageIndex.value > 0) {
        pageIndex.value--;
      }
    }
    function pageNext() {
      if (pageIndex.value < pageNum.value - 1) {
        pageIndex.value++;
      }
    }
    function jumpTo(index) {
      emit("on-jump", index + pageIndex.value * pageSize.value);
    }
    expose({
      reset,
      init
    });
    return {
      isNeedPage,
      pageIndex,
      pageNum,
      thumbs,
      thumbnailClasses,
      thumbnailStyle,
      pagePrev,
      pageNext,
      jumpTo,
      thumbListRef
    };
  }
});
const _hoisted_1$8 = { class: "stage-thumbnail" };
const _hoisted_2$8 = { class: "thumbnail" };
const _hoisted_3$6 = {
  class: "thumb-list",
  ref: "thumbListRef"
};
const _hoisted_4$2 = ["onClick"];
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconNext = resolveComponent("IconNext");
  const _component_IconPrev = resolveComponent("IconPrev");
  return openBlock(), createElementBlock("div", _hoisted_1$8, [
    createElementVNode("div", _hoisted_2$8, [
      _ctx.isNeedPage ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createElementVNode("i", {
          class: normalizeClass(["thumb-page-next", { enabled: _ctx.pageIndex < _ctx.pageNum - 1 }]),
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.pageNext && _ctx.pageNext(...args))
        }, [
          createVNode(_component_IconNext, {
            height: "18",
            width: "18"
          })
        ], 2),
        createElementVNode("i", {
          class: normalizeClass(["thumb-page-prev", { enabled: _ctx.pageIndex !== 0 }]),
          onClick: _cache[1] || (_cache[1] = (...args) => _ctx.pagePrev && _ctx.pagePrev(...args))
        }, [
          createVNode(_component_IconPrev, {
            height: "18",
            width: "18"
          })
        ], 2)
      ], 64)) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_3$6, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.thumbs, (thumb, index) => {
          return openBlock(), createElementBlock("a", {
            href: "javascript:;",
            key: index,
            class: normalizeClass(_ctx.thumbnailClasses(index)),
            style: normalizeStyle(_ctx.thumbnailStyle(thumb)),
            onClick: ($event) => _ctx.jumpTo(index)
          }, null, 14, _hoisted_4$2);
        }), 128))
      ], 512)
    ])
  ]);
}
var Thumbnail = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__scopeId", "data-v-4b4edd22"]]);

const _sfc_main$7 = {};

const _hoisted_1$7 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "20",
  height: "20",
  fill: "currentColor"
};
const _hoisted_2$7 = /*#__PURE__*/createElementVNode("path", { d: "M844.717 188.185c-0.958-13.89-17.49-20.43-27.548-10.884l-67.8 64.313a358.053 358.053 0 0 0-240.64-92.969c-198.606 0-360.2 162.998-360.2 363.355s161.594 363.355 360.2 363.355c104.135 0 203.133-45.453 271.609-124.713a27.252 27.252 0 0 0-2.61-38.202 26.674 26.674 0 0 0-37.855 2.642A305.4 305.4 0 0 1 508.73 821.215c-169.01 0-306.523-138.702-306.523-309.215 0-170.513 137.513-309.231 306.523-309.231a304.557 304.557 0 0 1 201.298 76.155l-74.52 70.69c-10.075 9.546-4.625 26.59 9.067 28.407l195.27 25.88a16.434 16.434 0 0 0 18.465-17.506l-13.593-198.21z" }, null, -1);
const _hoisted_3$5 = [
  _hoisted_2$7
];

function _sfc_render$7(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$7, _hoisted_3$5))
}
var IconRotateRight = /*#__PURE__*/_export_sfc(_sfc_main$7, [['render',_sfc_render$7]]);

const _sfc_main$6 = {};

const _hoisted_1$6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "20",
  height: "20",
  fill: "currentColor"
};
const _hoisted_2$6 = /*#__PURE__*/createElementVNode("path", { d: "M162.833 188.201c0.957-13.906 17.49-20.447 27.548-10.9l67.8 64.313a358.136 358.136 0 0 1 240.64-92.969c198.606 0 360.2 162.998 360.2 363.355s-161.594 363.355-360.2 363.355c-104.135 0-203.133-45.453-271.609-124.713a27.235 27.235 0 0 1 2.61-38.186 26.657 26.657 0 0 1 37.855 2.626 305.416 305.416 0 0 0 231.143 106.15c169.01 0 306.523-138.72 306.523-309.232S667.83 202.785 498.82 202.785a304.623 304.623 0 0 0-201.298 76.14l74.52 70.688c10.075 9.547 4.625 26.591-9.067 28.408l-195.27 25.88a16.434 16.434 0 0 1-18.465-17.506L162.833 188.2z" }, null, -1);
const _hoisted_3$4 = [
  _hoisted_2$6
];

function _sfc_render$6(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$6, _hoisted_3$4))
}
var IconRotateLeft = /*#__PURE__*/_export_sfc(_sfc_main$6, [['render',_sfc_render$6]]);

const _sfc_main$5 = {};

const _hoisted_1$5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "20",
  height: "20",
  fill: "currentColor"
};
const _hoisted_2$5 = /*#__PURE__*/createElementVNode("path", { d: "M831.57 476.87H192.43c-15.047 0-27.269 11.512-27.269 25.7 0 14.203 12.222 25.715 27.268 25.715h639.142c15.046 0 27.268-11.512 27.268-25.716 0-14.187-12.222-25.699-27.268-25.699z" }, null, -1);
const _hoisted_3$3 = [
  _hoisted_2$5
];

function _sfc_render$5(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$5, _hoisted_3$3))
}
var IconZoomOut = /*#__PURE__*/_export_sfc(_sfc_main$5, [['render',_sfc_render$5]]);

const _sfc_main$4 = {};

const _hoisted_1$4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "20",
  height: "20",
  fill: "currentColor"
};
const _hoisted_2$4 = /*#__PURE__*/createElementVNode("path", { d: "M831.505 484.699H539.3v-292.22a27.301 27.301 0 0 0-54.602 0v292.22h-292.22a27.301 27.301 0 0 0 0 54.602h292.22v292.204a27.301 27.301 0 1 0 54.602 0V539.3h292.204a27.301 27.301 0 1 0 0-54.602z" }, null, -1);
const _hoisted_3$2 = [
  _hoisted_2$4
];

function _sfc_render$4(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$4, _hoisted_3$2))
}
var IconZoomIn = /*#__PURE__*/_export_sfc(_sfc_main$4, [['render',_sfc_render$4]]);

var toolbar_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".stage-toolbar .toolbar[data-v-f229ca46] {\n  position: absolute;\n  right: 60px;\n  top: -40px;\n  display: flex;\n  z-index: 1;\n  transition: top 336ms;\n}\n.stage-toolbar .toolbar .rotate-right[data-v-f229ca46],\n.stage-toolbar .toolbar .rotate-left[data-v-f229ca46],\n.stage-toolbar .toolbar .zoom-out[data-v-f229ca46],\n.stage-toolbar .toolbar .zoom-in[data-v-f229ca46] {\n  margin: 0 5px;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  background-color: rgba(85, 85, 85, 0.4);\n  font-size: 20px;\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.stage-toolbar .toolbar .rotate-right[data-v-f229ca46]:hover,\n.stage-toolbar .toolbar .rotate-left[data-v-f229ca46]:hover,\n.stage-toolbar .toolbar .zoom-out[data-v-f229ca46]:hover,\n.stage-toolbar .toolbar .zoom-in[data-v-f229ca46]:hover {\n  background-color: #555;\n}")();

const _sfc_main$3 = defineComponent({
  components: {
    IconRotateRight,
    IconRotateLeft,
    IconZoomOut,
    IconZoomIn
  }
});
const _hoisted_1$3 = { class: "stage-toolbar" };
const _hoisted_2$3 = { class: "toolbar" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconZoomIn = resolveComponent("IconZoomIn");
  const _component_IconZoomOut = resolveComponent("IconZoomOut");
  const _component_IconRotateLeft = resolveComponent("IconRotateLeft");
  const _component_IconRotateRight = resolveComponent("IconRotateRight");
  return openBlock(), createElementBlock("div", _hoisted_1$3, [
    createElementVNode("div", _hoisted_2$3, [
      createElementVNode("i", {
        class: "zoom-in",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("on-zoom", "IN"))
      }, [
        createVNode(_component_IconZoomIn)
      ]),
      createElementVNode("i", {
        class: "zoom-out",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("on-zoom", "OUT"))
      }, [
        createVNode(_component_IconZoomOut)
      ]),
      createElementVNode("i", {
        class: "rotate-left",
        onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("on-rotate", "LEFT"))
      }, [
        createVNode(_component_IconRotateLeft)
      ]),
      createElementVNode("i", {
        class: "rotate-right",
        onClick: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("on-rotate", "RIGHT"))
      }, [
        createVNode(_component_IconRotateRight)
      ])
    ])
  ]);
}
var Toolbar = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__scopeId", "data-v-f229ca46"]]);

function isEmptyObject(obj) {
  for (const key in obj) {
    return false;
  }
  return true;
}

function parseHTML(str) {
  let dom = document.createElement("div");
  dom.innerHTML = str;

  return dom.childNodes[0];
}

function getTranslate(dom, isInverted) {
  if (dom) {
    let domRect = dom.getBoundingClientRect();
    return {
      height: isInverted ? domRect.width : domRect.height,
      width: isInverted ? domRect.height : domRect.width,
      left: domRect.left || 0,
      top: domRect.top || 0,
    };
  }

  return false;
}
function setTranslate(dom, props) {
  if (dom && props) {
    //reset transform
    dom.style.transform = "";
    let str = "";
    let { translateX, translateY, scaleX, scaleY, scale, rotate } = props;
    if (translateX !== undefined || translateY !== undefined) {
      str = `${translateX !== undefined ? translateX : 0}px, ${translateY !== undefined ? translateY : 0}px`;
      str = `translate(${str})`;
    }
    if (scaleX !== undefined && scaleY !== undefined) {
      str += `scale(${scaleX}, ${scaleY})`;
    } else if (scale !== undefined) {
      str += `scale(${scale})`;
    }
    if (rotate !== undefined) {
      str += `rotate(${rotate}deg)`;
    }
    if (str) {
      dom.style.transform = str;
    }

    let { height, width, left, top } = props;
    if (height !== undefined) {
      dom.style.height = `${height}px`;
    }
    if (width !== undefined) {
      dom.style.width = `${width}px`;
    }
    if (left !== undefined) {
      dom.style.left = `${left}px`;
    }
    if (top !== undefined) {
      dom.style.top = `${top}px`;
    }

    return dom;
  }
}

function getFitPos(dom, opts) {
  let canvasHeight, canvasWidth, height, width, left, top, minRatio;

  let matrix = getTranslate(dom);
  canvasHeight = matrix.height;
  canvasWidth = matrix.width;

  height = opts.height || canvasHeight;
  width = opts.width || canvasWidth;

  minRatio = Math.min(1, canvasWidth / width, canvasHeight / height);
  height = minRatio * height;
  width = minRatio * width;

  //adjust width/height to precisely fit into container
  height = height > canvasHeight - 0.5 ? canvasHeight : height;
  width = width > canvasWidth - 0.5 ? canvasWidth : width;

  left = Math.floor((canvasWidth - width) * 0.5);
  top = Math.floor((canvasHeight - height) * 0.5);

  return {
    height,
    width,
    left,
    top,
  };
}

class SlideEvent {
  constructor(instance) {
    this.slider = instance;
    this.root = instance.root;

    this.init();
  }

  init() {
    ["mousedown"].forEach((item) => {
      this[item] = this.setEventListener(this.root, item, this.onMouseDown.bind(this));
    });
  }
  setEventListener(dom, eventType, callback) {
    dom.addEventListener(eventType, callback);

    return {
      destroy() {
        dom.removeEventListener(eventType, callback);
      },
    };
  }

  onMouseDown(ev) {
    let $content = this.slider.current.$content;

    ev.preventDefault();
    if (ev.button === 2 || $content.isAnim) {
      return;
    }

    //容器宽高
    this.rootHeight = this.root.clientHeight;
    this.rootWidth = this.root.clientWidth;

    this.contentMovedOffset = null;
    //内容宽高、偏移量
    this.contentHeight = parseFloat($content.style.height);
    this.contentWidth = parseFloat($content.style.width);
    this.contentLeft = parseFloat($content.style.left);
    this.contentTop = parseFloat($content.style.top);

    //get/set thresholds
    this.isInverted = $content.isInverted;
    this.direction = {};
    if (this.isInverted) {
      this.minTranslateY = this.contentWidth * 0.5 - this.contentHeight * 0.5;
      this.minTranslateX = this.contentHeight * 0.5 - this.contentWidth * 0.5;

      this.maxTranslateY = this.rootHeight - this.contentHeight - this.minTranslateY;
      this.maxTranslateX = this.rootWidth - this.contentWidth - this.minTranslateX;

      //
      this.direction.x = this.contentHeight > this.rootWidth;
      this.direction.y = this.contentWidth > this.rootHeight;
    } else {
      this.minTranslateY = Math.max(0, this.rootHeight * 0.5 - this.contentHeight * 0.5);
      this.minTranslateX = Math.max(0, this.rootWidth * 0.5 - this.contentWidth * 0.5);

      this.maxTranslateY = Math.min(
        this.rootHeight - this.contentHeight,
        this.rootHeight * 0.5 - this.contentHeight * 0.5
      );
      this.maxTranslateX = Math.min(
        this.rootWidth - this.contentWidth,
        this.rootWidth * 0.5 - this.contentWidth * 0.5
      );

      //
      this.direction.y = this.contentHeight > this.rootHeight;
      this.direction.x = this.contentWidth > this.rootWidth;
    }

    //事件坐标点
    this.originPoints = this.startPoints = this.getPointerXY(ev);

    this.isPanning = false;
    this.isSwiping = false;
    this.canDrag = this.canDragging();
    if (this.canDrag) {
      this.isPanning = true;
    } else {
      this.isSwiping = true;
    }

    this.root.classList.add("stage-is-grabbing");
    //
    this.startTime = new Date().getTime();
    this.distanceX = this.distanceY = this.distance = 0;

    ["mousemove"].forEach((item) => {
      this[item] = this.setEventListener(this.root, item, this.onMouseMove.bind(this));
    });
    ["mouseup", "mouseleave"].forEach((item) => {
      this[item] = this.setEventListener(this.root, item, this.onMouseUp.bind(this));
    });
  }
  onMouseMove(ev) {
    this.newPoints = this.getPointerXY(ev);

    this.distanceX = this.getDistance(this.newPoints, this.startPoints, "x");
    this.distanceY = this.getDistance(this.newPoints, this.startPoints, "y");
    this.distance = this.getDistance(this.newPoints, this.startPoints);

    if (this.distance > 0) {
      if (this.isPanning) {
        this.onPan();
      } else if (this.isSwiping) {
        this.onSwipe();
      }
    }
  }
  onMouseUp(ev) {
    let swiping = this.isSwiping,
      panning = this.isPanning;

    this.endPoints = this.getPointerXY(ev);
    this.dMs = Math.max(new Date().getTime() - this.startTime, 1);

    this.root.classList.remove("stage-is-grabbing");

    if (this.requestId) {
      window.cancelAnimationFrame(this.requestId);
      this.requestId = null;
    }

    this.isSwiping = false;
    this.isPanning = false;
    this.slider.isDragging = false;

    //speed in px/ms
    this.velocityX = (this.distanceX / this.dMs) * 0.5;
    this.velocityY = (this.distanceY / this.dMs) * 0.5;

    if (panning) {
      this.endPanning();
    } else if (swiping) {
      this.endSwiping();
    }

    ["mousemove", "mouseup", "mouseleave"].forEach((item) => {
      this[item].destroy();
    });
  }

  //是否可拖拽
  canDragging() {
    let pos,
      rez = false;
    if (this.slider.current.isComplete) {
      rez = getTranslate(this.root);
      pos = getTranslate(this.slider.current.$content);

      if (pos && rez) {
        rez = pos.width - rez.width > 1.5 || pos.height - rez.height > 1.5;
      }
    }

    return rez;
  }
  //拖拽
  onPan() {
    //处理意外滑动
    let distance = this.getDistance(this.newPoints, this.originPoints);
    if (distance < 5) {
      this.startPoints = this.newPoints;
      return;
    }

    //获取拖拽位置
    this.contentMovedOffset = this.limitMovement(
      {
        minTranslateX: this.minTranslateX,
        minTranslateY: this.minTranslateY,
        maxTranslateX: this.maxTranslateX,
        maxTranslateY: this.maxTranslateY,
      },
      {
        distanceX: this.distanceX,
        distanceY: this.distanceY,
      },
      {
        left: this.contentLeft,
        top: this.contentTop,
      },
      {
        x: this.direction.x,
        y: this.direction.y,
      }
    );

    //在下一次 FPS 刷新时更新 pos
    if (this.requestId) {
      window.cancelAnimationFrame(this.requestId);
    }
    this.requestId = requestAnimationFrame(() => {
      setTranslate(this.slider.current.$content, {
        left: this.contentMovedOffset.left,
        top: this.contentMovedOffset.top,
        rotate: this.slider.current.$content.rotateAngle,
      });
    });
  }
  endPanning() {
    if (this.contentMovedOffset === null) {
      return;
    }

    if (this.dMs > 350) {
      this.offsetX = this.contentMovedOffset.left;
      this.offsetY = this.contentMovedOffset.top;
    } else {
      //continue movement
      this.offsetX = this.contentMovedOffset.left + this.velocityX * 500;
      this.offsetY = this.contentMovedOffset.top + this.velocityY * 500;
    }

    let currentLeft = parseFloat(this.slider.current.$content.style.left);
    let currentTop = parseFloat(this.slider.current.$content.style.top);
    if (currentLeft === this.offsetX && this.offsetY === currentTop) {
      return;
    }

    let contentBoundingRect;
    contentBoundingRect = this.limitPosition(
      {
        minTranslateX: this.minTranslateX,
        minTranslateY: this.minTranslateY,
        maxTranslateX: this.maxTranslateX,
        maxTranslateY: this.maxTranslateY,
      },
      {
        offsetX: this.offsetX,
        offsetY: this.offsetY,
      },
      {
        left: this.contentLeft,
        top: this.contentTop,
      },
      {
        x: this.direction.x,
        y: this.direction.y,
      }
    );
    contentBoundingRect.height = this.contentHeight;
    contentBoundingRect.width = this.contentWidth;

    this.slider.animate(this.slider.current, contentBoundingRect);
  }

  //切换
  onSwipe() {}
  endSwiping() {}

  destroy() {
    ["mousedown", "mousemove", "mouseup", "mouseleave"].forEach((item) => {
      this[item] && this[item].destroy();
    });
  }
}

SlideEvent.prototype.getPointerXY = (e) => {
  return {
    x: e.pageX || e.clientX,
    y: e.pageY || e.clientY,
  };
};
SlideEvent.prototype.getDistance = (p2, p1, what) => {
  if (p1 && p2) {
    if (what === "x") {
      return p2.x - p1.x;
    } else if (what === "y") {
      return p2.y - p1.y;
    } else {
      return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    }
  }

  return 0;
};

SlideEvent.prototype.limitMovement = (thresholds, distance, rect, direction) => {
  let { minTranslateX, minTranslateY, maxTranslateX, maxTranslateY } = thresholds;
  let { distanceX, distanceY } = distance;
  let { left, top } = rect;
  let { x, y } = direction;

  //computed offset
  let newOffsetX, newOffsetY;
  if (x) {
    newOffsetX = left + distanceX;
  } else {
    distanceX = 0;
    newOffsetX = left;
  }
  if (y) {
    newOffsetY = top + distanceY;
  } else {
    distanceY = 0;
    newOffsetY = top;
  }

  //force link
  //TO RIGHT
  if (distanceX > 0 && newOffsetX > minTranslateX + 0.5) {
    newOffsetX = minTranslateX - 1 + Math.pow(-minTranslateX + left + distanceX, 0.8) || 0;
  }
  //TO LEFT
  if (distanceX < 0 && newOffsetX < maxTranslateX - 0.5) {
    newOffsetX = maxTranslateX + 1 - Math.pow(maxTranslateX - left - distanceX, 0.8) || 0;
  }
  //TO BOTTOM
  if (distanceY > 0 && newOffsetY > minTranslateY + 0.5) {
    newOffsetY = minTranslateY - 1 + Math.pow(-minTranslateY + top + distanceY, 0.8) || 0;
  }
  //TO TOP
  if (distanceY < 0 && newOffsetY < maxTranslateY - 0.5) {
    newOffsetY = maxTranslateY + 1 - Math.pow(maxTranslateY - top - distanceY, 0.8) || 0;
  }

  return {
    left: newOffsetX,
    top: newOffsetY,
  };
};
SlideEvent.prototype.limitPosition = (thresholds, offset, rect, direction) => {
  let { minTranslateX, minTranslateY, maxTranslateX, maxTranslateY } = thresholds;
  let { offsetX, offsetY } = offset;
  let { left, top } = rect;
  let { x, y } = direction;

  //宽度超出边界
  if (x) {
    offsetX = offsetX > minTranslateX ? minTranslateX : offsetX;
    offsetX = offsetX < maxTranslateX ? maxTranslateX : offsetX;
  } else {
    offsetX = left;
  }

  //高度超出边界
  if (y) {
    offsetY = offsetY > minTranslateY ? minTranslateY : offsetY;
    offsetY = offsetY < maxTranslateY ? maxTranslateY : offsetY;
  } else {
    offsetY = top;
  }

  return {
    translateX: offsetX,
    translateY: offsetY,
  };
};

class Slider {
  // slides = {};
  // ratios = [0.25, 0.33, 0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4, 5]; //缩放比
  // ratiosIndex = 7;
  // angle = 0

  constructor($dom, images, config) {
    //this.images = images;
    this.root = $dom;

    this.slides = {};
    this.ratios = [0.25, 0.33, 0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4, 5];
    this.ratiosIndex = 7;
    this.angle = 0;

    //this.swipe(0);
  }

  //main
  preview(images, pos) {
    this.current = {};
    this.slides = {};
    this.images = images;

    this.addEvents();
    this.swipe(pos);
  }

  addEvents() {
    this.slideEvent = new SlideEvent(this);

    //this.keyboardHandler = () => {};
    //this.wheelHandler = () => {};
    this.resizeHandler = () => {
      if (this.current) {
        this.updateSlide(this.current);
      }

      this.ratiosIndex = 7;
      this.angle = 0;
    };

    //window.onresize
    window.addEventListener("resize", this.resizeHandler);
  }
  swipe(pos) {
    if (this.current && this.current.pos === pos) {
      this.updateSlide(this.current);
      this.current.$slide.classList.add("stage-slide--current");
      return;
    }

    let current, previous, isFirstRun;
    let slides = this.slides;
    let images = this.images;

    pos = parseInt(pos, 10);
    if (pos < 0 || pos > images.length) {
      throw new Error("the index is invalid.");
    }

    isFirstRun = isEmptyObject(slides);

    previous = this.current;
    //create slides
    current = this.createSlide(pos);
    if (images.length > 1) {
      if (current.pos < images.length - 1) {
        this.createSlide(pos + 1);
      }
      if (current.pos > 0) {
        this.createSlide(pos - 1);
      }
    }

    this.current = current;
    //make sure current slide is visible
    this.current.$slide.classList.add("stage-slide--current");

    if (isFirstRun) {
      this.loadContent(current);
      this.preload();

      return;
    }

    if (previous.pos !== current.pos) {
      previous.isComplete = false;
    }
    previous.$slide.classList.remove("stage-slide--current");

    if (current.isLoaded) {
      this.showContent(current);
    } else {
      this.loadContent(current);
    }
    this.preload();
  }

  updateSlide(slide) {
    this.ratiosIndex = 7;
    this.angle = 0;

    if (slide.$content && (slide.width || slide.height)) {
      //reset
      slide.$content.isInverted = false;
      slide.$content.rotateAngle = 0;

      if (slide.isLoaded) {
        //important !!
        let fitPos = getFitPos(this.root, slide);

        slide.$content.primeBoundingRect = {
          height: fitPos.height,
          width: fitPos.width,
        };

        setTranslate(slide.$content, fitPos);
      }
    }
  }
  //create $slide
  createSlide(pos) {
    let $slide,
      image = this.images[pos];

    if (this.slides[pos] === undefined && this.images[pos]) {
      $slide = parseHTML('<div class="stage-slide"></div>');
      this.root.appendChild($slide);

      this.slides[pos] = Object.assign(
        {},
        {
          src: image.src,
          pos: pos,
          isLoaded: false,
          $slide: $slide,
        }
      );
      this.updateSlide(this.slides[pos]);
    }

    return this.slides[pos];
  }

  //create $content
  loadContent(slide) {
    let $content;
    if (slide.isLoading || slide.isLoaded) return;

    slide.isLoading = true;
    setTimeout(() => {
      const $img = slide.$image;

      if (slide.isLoading && !$img.complete) {
        this.showLoading(slide);
      }
    }, 50);

    //this will be wrapper containing both ghost and actual image
    $content = parseHTML('<div class="slide-content"></div>');
    $content.classList.add("slide-is-hidden");
    slide.$slide.appendChild($content);
    slide.$content = $content;

    this.loadImage(slide);
  }

  //create $image
  loadImage(slide) {
    let $image = document.createElement("img");
    $image.onload = () => {
      //default
      slide.height = $image.naturalHeight;
      slide.width = $image.naturalWidth;

      this.afterLoad(slide);
    };

    $image.setAttribute("src", slide.src);
    slide.$content.appendChild($image);
    slide.$image = $image;
  }
  afterLoad(slide) {
    this.hideLoading(slide);

    slide.isLoading = false;
    slide.isLoaded = true;

    slide.$content.addEventListener("contextmenu", (e) => {
      if (e.button === 2) {
        e.preventDefault();
      }
      return true;
    });

    if (slide.pos === this.current.pos) {
      //update cursor style
      this.root.classList.add("stage-can-swipe", "stage-can-pan");
    }

    this.showContent(slide);
  }

  //preload prev & next
  preload() {
    let current = this.current,
      prev,
      next;

    next = this.slides[current.pos + 1];
    prev = this.slides[current.pos - 1];

    if (prev) {
      this.loadContent(prev);
    }
    if (next) {
      this.loadContent(next);
    }
  }

  //rendered show
  showContent(slide) {
    this.updateSlide(slide);

    //simply show content if no effect
    slide.$content.classList.remove("slide-is-hidden");
    if (slide.pos === this.current.pos) {
      this.complete();
    }
  }
  complete() {
    let slides = {};
    if (!this.current.isLoaded) return;
    if (!this.current.isComplete) this.current.isComplete = true;

    //update slides object
    Object.keys(this.slides).forEach((index) => {
      let slide = this.slides[index];
      if (slide.pos >= this.current.pos - 1 && slide.pos <= this.current.pos + 1) {
        slides[slide.pos] = slide;
      } else if (slide) {
        slide.$slide.remove();
      }
    });

    this.slides = slides;
  }

  //add loading
  showLoading(slide) {
    let $spinner;
    slide = slide || this.current;

    if (slide && slide.$spinner === undefined) {
      $spinner = parseHTML('<div class="loading"></div>');
      $spinner.style.display = "block";
      $spinner.style.opacity = "1";
      slide.$slide.appendChild($spinner);

      slide.$spinner = $spinner;
    }
  }
  hideLoading(slide) {
    slide = slide || this.current;

    if (slide && slide.$spinner) {
      slide.$spinner.remove();
      slide.$spinner = undefined;
    }
  }

  animate(slide, to, callback) {
    let { $slide, $content } = slide;
    let transitionendFlag, containerRect, contentRect, ratio, angle, from, pan;

    from = $content.primeBoundingRect;

    $slide.classList.remove("stage-slide--animating");

    transitionendFlag = true;
    containerRect = getTranslate($slide);
    contentRect = getTranslate($content, $content.isInverted);

    const transitionendHandler = (e) => {
      // 避免多次执行
      if (e.target === e.currentTarget && transitionendFlag) {
        transitionendFlag = false;
        $content.isAnim = false;
        $slide.classList.remove("stage-slide--animating");

        if (
          to.scale !== undefined ||
          to.rotate !== undefined ||
          (to.translateX !== undefined && to.translateY !== undefined)
        ) {
          if (to.rotate !== undefined) {
            setTranslate($content, {
              left: containerRect.width * 0.5 - contentRect.height * 0.5,
              top: containerRect.height * 0.5 - contentRect.width * 0.5,
              rotate: angle % 360,
            });
            //暂存
            $content.rotateAngle = angle % 360;
          }
          if (to.scale !== undefined) {
            setTranslate($content, {
              left: containerRect.width * 0.5 - from.width * to.scale * 0.5,
              top: containerRect.height * 0.5 - from.height * to.scale * 0.5,
              rotate: angle,
              height: from.height * to.scale,
              width: from.width * to.scale,
            });
          }
        }
        callback && callback();

        $content.removeEventListener("transitionend", transitionendHandler);
      }
    };

    $content.addEventListener("transitionend", transitionendHandler);

    if (
      to.scale !== undefined ||
      to.rotate !== undefined ||
      (to.translateX !== undefined && to.translateY !== undefined)
    ) {
      angle = to.rotate === undefined ? $content.rotateAngle : to.rotate;
      pan = {
        X: to.translateX,
        Y: to.translateY,
      };

      if (to.scale !== undefined) {
        //compute by width
        ratio = Math.round(((from.width * to.scale) / contentRect.width) * 100) / 100;
      }

      $slide.classList.add("stage-slide--animating");
      $content.isAnim = true;

      setTranslate($content, {
        rotate: angle,
        scale: ratio,
        left: pan.X,
        top: pan.Y,
      });
    }
  }
  rotate(flag) {
    if (this.current.$content.isAnim) return;

    this.current.$content.isInverted = (this.angle / 90) % 2 === 0;
    if (this.current.isComplete) {
      let angle;
      switch (flag) {
        case "RIGHT":
          angle = this.angle = (this.angle % 360) + 90;
          this.animate(this.current, {
            rotate: angle % 360 === 0 && angle !== 0 ? +360 : angle % 360,
          });
          break;
        case "LEFT":
          angle = this.angle = (this.angle % 360) - 90;
          this.animate(this.current, {
            rotate: angle % 360 === 0 && angle !== 0 ? -360 : angle % 360,
          });
          break;
      }
    }
  }
  zoom(flag) {
    if (this.current.$content.isAnim) return;

    if (this.current.isComplete) {
      let { ratios, ratiosIndex } = this;

      if (ratiosIndex > 0 && ratiosIndex < ratios.length - 1) {
        switch (flag) {
          case "OUT":
            this.animate(this.current, {
              scale: ratios[--ratiosIndex],
            });
            this.ratiosIndex--;
            break;
          case "IN":
            this.animate(this.current, {
              scale: ratios[++ratiosIndex],
            });
            this.ratiosIndex++;
            break;
        }
      }
    }
  }

  reset() {
    this.slideEvent.destroy();
    this.slideEvent = null;

    if (this.current) {
      this.current.$slide.classList.remove("stage-slide--current", "stage-slide--animating");
      this.current.$content.isAnim = false;

      //remove listener
      window.removeEventListener("resize", this.resizeHandler);
    }
  }
}

var stage_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".stage-container[data-v-b966069a] {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n}\n.stage-container[data-v-b966069a]:hover .stage-indicator .navigator .navigator-prev {\n  transform: translateX(100%);\n}\n.stage-container[data-v-b966069a]:hover .stage-indicator .navigator .navigator-next {\n  transform: translateX(-100%);\n}\n.stage-container[data-v-b966069a]:hover .stage-indicator .indicator {\n  visibility: visible;\n  opacity: 1;\n}\n.stage-container[data-v-b966069a]:hover .stage-thumbnail .thumbnail {\n  bottom: 0;\n}\n.stage-container[data-v-b966069a]:hover .stage-toolbar .toolbar {\n  top: 20px;\n}\n.stage-container[data-v-b966069a] .stage {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  top: 0;\n}\n.stage-container[data-v-b966069a] .stage .stage-slide {\n  display: none;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  top: 0;\n  text-align: left;\n}\n.stage-container[data-v-b966069a] .stage .stage-slide .slide-content {\n  display: inline-block;\n  text-align: center;\n  position: relative;\n  transition-property: transform, top, left;\n  transform-origin: center;\n  user-select: none;\n}\n.stage-container[data-v-b966069a] .stage .stage-slide .slide-content.slide-is-hidden {\n  visibility: hidden;\n  position: absolute !important;\n}\n.stage-container[data-v-b966069a] .stage .stage-slide .slide-content img {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  max-height: none;\n  max-width: none;\n  background: transparent;\n  padding: 0;\n  border: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  vertical-align: middle;\n  user-select: none;\n}\n.stage-container[data-v-b966069a] .stage .stage-slide .loading {\n  display: none;\n  height: 2.5em;\n  width: 2.5em;\n  line-height: 1.15;\n  opacity: 0;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%) rotate(165deg);\n  transition: opacity 5s cubic-bezier(0.47, 0, 0.74, 0.71);\n}\n.stage-container[data-v-b966069a] .stage .stage-slide .loading:before, .stage-container[data-v-b966069a] .stage .stage-slide .loading:after {\n  content: \"\";\n  height: 0.5em;\n  width: 0.5em;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  border-radius: 0.25em;\n  transform: translate(-50%, -50%);\n}\n.stage-container[data-v-b966069a] .stage .stage-slide .loading:before {\n  animation: before-b966069a 2s infinite;\n}\n.stage-container[data-v-b966069a] .stage .stage-slide .loading:after {\n  animation: after-b966069a 2s infinite;\n}\n.stage-container[data-v-b966069a] .stage .stage-slide.stage-slide--animating .slide-content {\n  transition-duration: 336ms;\n}\n.stage-container[data-v-b966069a] .stage .stage-slide.stage-slide--current {\n  display: block;\n}\n.stage-container[data-v-b966069a] .stage.stage-can-swipe .slide-content, .stage-container[data-v-b966069a] .stage.stage-can-pan .slide-content {\n  cursor: grab;\n}\n.stage-container[data-v-b966069a] .stage.stage-is-grabbing .slide-content {\n  cursor: grabbing;\n}\n@keyframes before-b966069a {\n0% {\n    width: 0.5em;\n    box-shadow: 1em -0.5em rgba(225, 20, 98, 0.75), -1em 0.5em rgba(111, 202, 220, 0.75);\n}\n35% {\n    width: 2.5em;\n    box-shadow: 0 -0.5em rgba(225, 20, 98, 0.75), 0 0.5em rgba(111, 202, 220, 0.75);\n}\n70% {\n    width: 0.5em;\n    box-shadow: -1em -0.5em rgba(225, 20, 98, 0.75), 1em 0.5em rgba(111, 202, 220, 0.75);\n}\n100% {\n    box-shadow: 1em -0.5em rgba(225, 20, 98, 0.75), -1em 0.5em rgba(111, 202, 220, 0.75);\n}\n}\n@keyframes after-b966069a {\n0% {\n    height: 0.5em;\n    box-shadow: 0.5em 1em rgba(61, 184, 143, 0.75), -0.5em -1em rgba(233, 169, 32, 0.75);\n}\n35% {\n    height: 2.5em;\n    box-shadow: 0.5em 0 rgba(61, 184, 143, 0.75), -0.5em 0 rgba(233, 169, 32, 0.75);\n}\n70% {\n    height: 0.5em;\n    box-shadow: 0.5em -1em rgba(61, 184, 143, 0.75), -0.5em 1em rgba(233, 169, 32, 0.75);\n}\n100% {\n    box-shadow: 0.5em 1em rgba(61, 184, 143, 0.75), -0.5em -1em rgba(233, 169, 32, 0.75);\n}\n}")();

const _sfc_main$2 = defineComponent({
  components: {
    Indicator,
    Thumbnail,
    Toolbar
  },
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { expose }) {
    let slider;
    let thumbnailRef = ref();
    let sliderRef = ref();
    let currentIndex = ref(0);
    const thumbnails = computed(() => props.images && props.images.map((img) => img.thumbnail));
    const count = computed(() => props.images && props.images.length);
    function preview(images, pos) {
      currentIndex.value = pos;
      slider.preview(images, pos);
      thumbnailRef.value.init();
    }
    function reset() {
      slider.reset();
      thumbnailRef.value.reset();
    }
    function swipe() {
      slider.swipe(currentIndex.value);
    }
    function handlePrev() {
      currentIndex.value--;
      swipe();
    }
    function handleNext() {
      currentIndex.value++;
      swipe();
    }
    function handleJump(index) {
      currentIndex.value = index;
      swipe();
    }
    function handleRotate(flag) {
      slider.rotate(flag);
    }
    function handleZoom(flag) {
      slider.zoom(flag);
    }
    onMounted(() => {
      slider = new Slider(sliderRef.value);
    });
    expose({
      preview,
      reset
    });
    return {
      thumbnailRef,
      sliderRef,
      currentIndex,
      thumbnails,
      count,
      handlePrev,
      handleNext,
      handleJump,
      handleRotate,
      handleZoom
    };
  }
});
const _hoisted_1$2 = { class: "stage-container" };
const _hoisted_2$2 = {
  class: "stage",
  ref: "sliderRef"
};
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Indicator = resolveComponent("Indicator");
  const _component_Thumbnail = resolveComponent("Thumbnail");
  const _component_Toolbar = resolveComponent("Toolbar");
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    createVNode(_component_Indicator, {
      count: _ctx.count,
      index: _ctx.currentIndex,
      onOnPrev: _ctx.handlePrev,
      onOnNext: _ctx.handleNext
    }, null, 8, ["count", "index", "onOnPrev", "onOnNext"]),
    createVNode(_component_Thumbnail, {
      ref: "thumbnailRef",
      thumbnails: _ctx.thumbnails,
      index: _ctx.currentIndex,
      onOnJump: _ctx.handleJump
    }, null, 8, ["thumbnails", "index", "onOnJump"]),
    createVNode(_component_Toolbar, {
      onOnRotate: _ctx.handleRotate,
      onOnZoom: _ctx.handleZoom
    }, null, 8, ["onOnRotate", "onOnZoom"]),
    createElementVNode("div", _hoisted_2$2, null, 512)
  ]);
}
var Stage = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-b966069a"]]);

var index_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".gallery-dialog[data-v-60d008cc] {\n  position: relative;\n  font-size: 14px;\n  z-index: 10001;\n}\n.gallery-dialog .gallery-wrapper[data-v-60d008cc] {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.gallery-dialog .gallery[data-v-60d008cc] {\n  min-height: 400px;\n  min-width: 750px;\n  height: 83.5%;\n  width: 87.5%;\n  background-color: #000000;\n  position: relative;\n}\n.gallery-dialog .gallery .close[data-v-60d008cc] {\n  height: 50px;\n  width: 50px;\n  position: absolute;\n  right: -25px;\n  top: -25px;\n  background-color: #313131;\n  border-radius: 50%;\n  color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n}\n.gallery-dialog .gallery .close[data-v-60d008cc]:hover {\n  color: #5293f5;\n}\n.gallery-dialog .mask[data-v-60d008cc] {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  background-color: #1e1e1e;\n  opacity: 0.8;\n}\n.gallery-dialog.bounce-in-enter-active[data-v-60d008cc] {\n  transition-duration: 0.3s;\n}\n.gallery-dialog.bounce-in-enter-active .gallery[data-v-60d008cc] {\n  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n.gallery-dialog.bounce-in-enter-active .mask[data-v-60d008cc] {\n  transition: opacity 0.3s cubic-bezier(0.47, 0, 0.74, 0.71);\n}\n.gallery-dialog.bounce-in-leave-active[data-v-60d008cc] {\n  transition-duration: 0.3s;\n}\n.gallery-dialog.bounce-in-leave-active .gallery[data-v-60d008cc] {\n  transition: transform 0.3s cubic-bezier(0.6, -0.28, 0.735, 0.045);\n}\n.gallery-dialog.bounce-in-leave-active .mask[data-v-60d008cc] {\n  transition: opacity 0.3s cubic-bezier(0.22, 0.61, 0.36, 1);\n}\n.gallery-dialog.bounce-in-enter-from .gallery[data-v-60d008cc], .gallery-dialog.bounce-in-leave-to .gallery[data-v-60d008cc] {\n  transform: scale(0);\n}\n.gallery-dialog.bounce-in-enter-from .mask[data-v-60d008cc], .gallery-dialog.bounce-in-leave-to .mask[data-v-60d008cc] {\n  opacity: 0;\n}")();

const _sfc_main$1 = defineComponent({
  components: {
    IconClose,
    Stage
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const stageRef = ref();
    const visible = ref(false);
    watch(
      () => props.modelValue,
      (val) => visible.value = val
    );
    function toEmerge() {
      stageRef.value && stageRef.value.preview(props.images, props.index);
    }
    function toReset() {
      stageRef.value && stageRef.value.reset();
    }
    function close() {
      visible.value = false;
      emit("update:modelValue", false);
    }
    return {
      stageRef,
      visible,
      close,
      toEmerge,
      toReset
    };
  }
});
const _withScopeId$1 = (n) => (pushScopeId("data-v-60d008cc"), n = n(), popScopeId(), n);
const _hoisted_1$1 = { class: "gallery-dialog" };
const _hoisted_2$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "mask" }, null, -1));
const _hoisted_3$1 = { class: "gallery-wrapper" };
const _hoisted_4$1 = { class: "gallery" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Stage = resolveComponent("Stage");
  const _component_IconClose = resolveComponent("IconClose");
  return openBlock(), createBlock(Transition, {
    name: "bounce-in",
    onAfterEnter: _ctx.toEmerge,
    onAfterLeave: _ctx.toReset
  }, {
    default: withCtx(() => [
      withDirectives(createElementVNode("div", _hoisted_1$1, [
        _hoisted_2$1,
        createElementVNode("div", _hoisted_3$1, [
          createElementVNode("div", _hoisted_4$1, [
            createVNode(_component_Stage, {
              ref: "stageRef",
              images: _ctx.images
            }, null, 8, ["images"]),
            createElementVNode("i", {
              class: "close",
              onClick: _cache[0] || (_cache[0] = (...args) => _ctx.close && _ctx.close(...args))
            }, [
              createVNode(_component_IconClose)
            ])
          ])
        ])
      ], 512), [
        [vShow, _ctx.visible]
      ])
    ]),
    _: 1
  }, 8, ["onAfterEnter", "onAfterLeave"]);
}
var index = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-60d008cc"]]);

function getScrollBarWidth() {
  const outer = document.createElement("div");
  outer.className = `player-scrollbar__wrap`;
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.position = "absolute";
  outer.style.top = "-9999px";
  document.body.appendChild(outer);
  const widthNoScroll = outer.offsetWidth;
  outer.style.overflow = "scroll";
  const inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);
  const widthWithScroll = inner.offsetWidth;
  const scrollBarWidth = widthNoScroll - widthWithScroll;
  if (outer.parentNode) {
    outer.parentNode.removeChild(outer);
  }
  return scrollBarWidth;
}
const useLockscreen = (trigger) => {
  let scrollBarWidth = 0;
  let withoutHiddenClass = false;
  let bodyWidth = "0";
  let hiddenClass = "player-dialog--hidden";
  const cleanup = () => {
    document.body.classList.remove(hiddenClass);
    if (withoutHiddenClass) {
      document.body.style.width = bodyWidth;
    }
  };
  watch(trigger, (visible) => {
    if (visible) {
      withoutHiddenClass = !document.body.classList.contains(hiddenClass);
      if (withoutHiddenClass) {
        bodyWidth = document.body.style.width;
      }
      scrollBarWidth = getScrollBarWidth();
      const bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
      const style = window.getComputedStyle(document.body);
      const bodyOverflowY = style["overflowY"];
      if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === "scroll") && withoutHiddenClass) {
        document.body.style.width = `calc(100% - ${scrollBarWidth}px)`;
      }
      document.body.classList.add(hiddenClass);
    } else {
      cleanup();
    }
  });
  onScopeDispose(() => cleanup());
};

var previewDialog_vue_vue_type_style_index_0_scoped_true_lang = /* #__PURE__ */ (() => ".overlay[data-v-414cbe49] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  top: 0;\n  z-index: 9999;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.overlay .fixed-in-center[data-v-414cbe49] {\n  padding: 16px;\n  text-align: center;\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  top: 0;\n  overflow: auto;\n}\n.overlay .fixed-in-center .dialog[data-v-414cbe49] {\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n  height: 100%;\n  width: 80%;\n  overflow: hidden;\n  backface-visibility: hidden;\n}\n.overlay .fixed-in-center[data-v-414cbe49]::after {\n  content: \"\";\n  display: inline-block;\n  height: 100%;\n  width: 0;\n  vertical-align: middle;\n}\n.overlay .fixed-in-center.fullscreen[data-v-414cbe49] {\n  padding: 0;\n}\n.overlay .fixed-in-center.fullscreen .dialog[data-v-414cbe49] {\n  height: 100%;\n  width: 100%;\n}\n.overlay .fixed-in-center.fullscreen .main[data-v-414cbe49] {\n  height: calc(100% - 54px);\n}\n.overlay .dialog[data-v-414cbe49] {\n  font-family: PingFangSC-Regular, PingFang SC, sans-serif;\n  font-size: 14px;\n}\n.overlay .dialog-header[data-v-414cbe49] {\n  height: 54px;\n  background: #FFFFFF;\n  box-shadow: 0 4px 6px 0 rgba(140, 149, 179, 0.08);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.overlay .dialog-header .backup[data-v-414cbe49] {\n  padding: 5px;\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  outline: 0;\n  font-size: 16px;\n  cursor: pointer;\n  user-select: none;\n  z-index: 100;\n}\n.overlay .dialog-header .backup .dialog-close-icon[data-v-414cbe49] {\n  color: #000;\n}\n.overlay .dialog-header .title[data-v-414cbe49] {\n  padding: 0 40px;\n  line-height: 22px;\n  font-size: 16px;\n  color: #171A1D;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.overlay .dialog-close[data-v-414cbe49] {\n  position: absolute;\n  padding: 5px;\n  right: 35px;\n  top: 15px;\n  border: none;\n  outline: 0;\n  font-size: 16px;\n  cursor: pointer;\n  user-select: none;\n  z-index: 100;\n}\n.overlay .dialog-close-icon[data-v-414cbe49] {\n  vertical-align: middle;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  height: 1.5em;\n  width: 1.5em;\n  line-height: 1.5em;\n  position: relative;\n  fill: currentColor;\n  color: #FFF;\n}\n.overlay .dialog-close-icon svg[data-v-414cbe49] {\n  height: 100%;\n  width: 100%;\n}\n.overlay .dialog .main[data-v-414cbe49] {\n  height: 100%;\n  width: 100%;\n}\n.fade-in-linear-enter-from[data-v-414cbe49],\n.fade-in-linear-leave-to[data-v-414cbe49] {\n  opacity: 0;\n}\n.fade-in-linear-enter-active[data-v-414cbe49],\n.fade-in-linear-leave-active[data-v-414cbe49] {\n  transition: opacity 0.2s linear;\n}\n.fade-in-linear-enter-active .fixed-in-center[data-v-414cbe49] {\n  animation: fade-in-414cbe49 0.3s;\n}\n.fade-in-linear-leave-active .fixed-in-center[data-v-414cbe49] {\n  animation: fade-in-414cbe49 0.3s reverse;\n}\n@keyframes fade-in-414cbe49 {\n0% {\n    transform: translate3d(0, -20px, 0);\n    opacity: 0;\n}\n100% {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n}\n}")();

var previewDialog_vue_vue_type_style_index_1_lang = /* #__PURE__ */ (() => ".player-dialog--hidden {\n  overflow: hidden;\n}")();

const _sfc_main = defineComponent({
  inheritAttrs: false,
  components: {
    MaterialResPlayer
  },
  props: {
    material: {
      type: Object
    },
    mode: String
  },
  setup(props, { emit }) {
    const visible = ref(false);
    const faded = ref(false);
    watch(visible, (val) => {
      if (val) {
        faded.value = val;
      } else {
        setTimeout(() => faded.value = val, 300);
      }
    });
    useLockscreen(faded);
    function close() {
      visible.value = false;
      nextTick(() => emit("action", "close"));
    }
    onMounted(() => visible.value = true);
    return {
      visible,
      close,
      faded
    };
  }
});
const _withScopeId = (n) => (pushScopeId("data-v-414cbe49"), n = n(), popScopeId(), n);
const _hoisted_1 = { class: "overlay" };
const _hoisted_2 = { class: "dialog" };
const _hoisted_3 = {
  key: 0,
  class: "dialog-header"
};
const _hoisted_4 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("i", { class: "dialog-close-icon" }, [
  /* @__PURE__ */ createElementVNode("svg", {
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createElementVNode("path", {
      fill: "currentColor",
      d: "M685.248 104.704a64 64 0 0 1 0 90.496L368.448 512l316.8 316.8a64 64 0 0 1-90.496 90.496L232.704 557.248a64 64 0 0 1 0-90.496l362.048-362.048a64 64 0 0 1 90.496 0z"
    })
  ])
], -1));
const _hoisted_5 = [
  _hoisted_4
];
const _hoisted_6 = { class: "title" };
const _hoisted_7 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("i", { class: "dialog-close-icon" }, [
  /* @__PURE__ */ createElementVNode("svg", {
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createElementVNode("path", {
      fill: "currentColor",
      d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
    })
  ])
], -1));
const _hoisted_8 = [
  _hoisted_7
];
const _hoisted_9 = { class: "main" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MaterialResPlayer = resolveComponent("MaterialResPlayer");
  return openBlock(), createBlock(Transition, {
    name: "fade-in-linear",
    onAfterLeave: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("vanish"))
  }, {
    default: withCtx(() => [
      withDirectives(createElementVNode("div", _hoisted_1, [
        createElementVNode("div", {
          class: normalizeClass(["fixed-in-center", { "fullscreen": _ctx.mode === "h5" }])
        }, [
          createElementVNode("div", _hoisted_2, [
            _ctx.mode === "h5" ? (openBlock(), createElementBlock("div", _hoisted_3, [
              createElementVNode("span", {
                class: "backup",
                onClick: _cache[0] || (_cache[0] = (...args) => _ctx.close && _ctx.close(...args))
              }, _hoisted_5),
              createElementVNode("h3", _hoisted_6, toDisplayString(_ctx.material.materialName), 1)
            ])) : (openBlock(), createElementBlock("span", {
              key: 1,
              class: "dialog-close",
              onClick: _cache[1] || (_cache[1] = (...args) => _ctx.close && _ctx.close(...args))
            }, _hoisted_8)),
            createElementVNode("div", _hoisted_9, [
              _ctx.faded ? (openBlock(), createBlock(_component_MaterialResPlayer, mergeProps({
                key: 0,
                material: _ctx.material,
                mode: _ctx.mode
              }, _ctx.$attrs), null, 16, ["material", "mode"])) : createCommentVNode("", true)
            ])
          ])
        ], 2)
      ], 512), [
        [vShow, _ctx.visible]
      ])
    ]),
    _: 1
  });
}
var PreviewDialog = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-414cbe49"]]);

function initInstance(props, container) {
  const vnode = h(PreviewDialog, props);
  render(vnode, container);
  document.body.appendChild(container.firstElementChild);
  return vnode.component;
}
function genContainer() {
  return document.createElement("div");
}
function preview(material, options = {}) {
  return new Promise((resolve, reject) => {
    const container = genContainer();
    options.material = material;
    options.onVanish = () => {
      render(null, container);
    };
    const instance = initInstance(options, container);
    resolve(instance.proxy);
  });
}

export { index as Gallery, livePlayer as LivePlayer, MaterialResPlayer, preview };
